<template>
  <div class="x3-order-detail-page">
    <div class="page-body">
      <!-- 顶部订单状态 orderStatus： 0-> 待付款  1-> 已付款 2-> 已取消 3-> 已失效  4-> 已作废  -->
      <template>
        <template v-if="order.orderStatus == 0">
          <div class="top-bg">
            <van-icon class="l" name="underway" size="calc(var(--w) * 24)" />
            <div class="r">
              <div class="r1">待付款</div>
              <div class="r2">
                <van-count-down
                  class="count-down-text"
                  :time="order.countDownTime"
                  :format="formatDownTime(order.countDownTime, 0)"
                  @finish="countDownFinish"
                />
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="order.orderStatus == 1">
          <div class="top-bg">
            <van-icon class="l" name="checked" size="calc(var(--w) * 24)" />
            <div class="r">
              <div class="r1">已付款</div>
              <div class="r2">
                <template v-if="order.oweMoney > 0"
                  >订单共欠费￥{{ order.oweMoney | formatNumber }}，请及时补交。</template
                >
                <template v-else>已完成订单支付</template>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="order.orderStatus == 2">
          <div class="top-bg gray">
            <van-icon class="l" name="clear" size="calc(var(--w) * 24)" />
            <div class="r">
              <div class="r1">已取消</div>
              <div class="r2">订单已被取消</div>
            </div>
          </div>
        </template>
        <template v-else-if="order.orderStatus == 3">
          <div class="top-bg gray">
            <van-icon class="l" name="clear" size="calc(var(--w) * 24)" />
            <div class="r">
              <div class="r1">已失效</div>
              <div class="r2">订单已超时</div>
            </div>
          </div>
        </template>
        <template v-else-if="order.orderStatus == 4">
          <div class="top-bg gray">
            <van-icon class="l" name="clear" size="calc(var(--w) * 24)" />
            <div class="r">
              <div class="r1">已作废</div>
              <div class="r2">订单已作废</div>
            </div>
          </div>
        </template>
        <!-- 退款订单没有状态，直接写死 -->
        <template v-else-if="order.orderType == 2">
          <div class="top-bg">
            <van-icon class="l" name="checked" size="calc(var(--w) * 24)" />
            <div class="r">
              <div class="r1">已退款</div>
              <div class="r2" v-if="!hasOnlineRefund || (hasOnlineRefund && onlineRefundStatus == 2)">已成功退款</div>
              <div class="r2" v-else>
                <span v-if="onlineRefundStatus == 1">
                  线上退款中¥{{ onlineRefundMoney | formatNumber }}，将在1-3个工作日内到账
                </span>
                <span v-else>
                  线下已退款¥{{ order.offlineRefundMoney | formatNumber }}，线上退款失败¥{{ onlineRefundMoney | formatNumber }}
                </span>
              </div>
              
            </div>
          </div>
        </template>
        <!-- 结转订单没有状态，直接写死 -->
        <template v-else-if="order.orderType == 3">
          <div class="top-bg">
            <van-icon class="l" name="checked" size="calc(var(--w) * 24)" />
            <div class="r">
              <div class="r1">已结转</div>
              <div class="r2">结转费用已存入学员电子钱包</div>
            </div>
          </div>
        </template>
      </template>

      <!-- 1、预存、收费、转课订单 -->
      <template v-if="order.orderType == 0 || order.orderType == 1">
        <!-- 1.1、收费、转课订单 -->
        <template v-if="order.sourceType != 7">
          <!-- 收费、转课订单学员 -->
          <div class="b1">
            <div class="l1">
              {{ order.buyerNameStr }}
            </div>
            <div class="line" v-if="appscene == 'teacher' && order.orderType == 0 && order.sourceType !== 10">
              <div class="l">关联意向：</div>
              <div class="r">
                {{ (order.intentionClue && order.intentionClue.content) || '-' }}
                <van-icon
                  name="edit"
                  class="editicon"
                  v-if="isShowEdit2"
                  @click.stop="updateClue()"
                />
              </div>
            </div>
            <div class="line">
              <div class="l">{{order.sourceType == 10 ? '充值校区':'收费校区'}}：</div>
              <div class="r">
                {{ order.campusName }}
              </div>
            </div>
            <!-- <div class="l2">收费校区：{{ order.campusName }}</div> -->
          </div>

          <!-- 收费、转课订单项目 -->
          <template v-for="item in order.orderItems">
            <!-- 1.1.1、课程/班级 -->
            <div
              class="b2"
              v-if="item.commodityType === 1 || item.commodityType === 2"
              :key="item.id"
            >
              <div class="head">
                <svg
                  class="vxm-icon l"
                  aria-hidden="true"
                  font-size="24"
                  style="margin-right: calc(var(--gap) * 8)"
                >
                  <use v-if="item.commodityType === 1" xlink:href="#vxm-icon-banji"></use>
                  <use v-else-if="item.commodityType === 2" xlink:href="#vxm-icon-kecheng"></use>
                </svg>

                <div class="r" v-if="item.commodityType === 1">
                  <div class="r1 van-ellipsis">
                    {{ item.productName }}
                  </div>
                  <div class="r2 van-ellipsis">
                    {{ item.curriculumName }}
                  </div>
                </div>

                <div class="r" v-if="item.commodityType === 2">
                  <div class="r1 van-ellipsis">
                    {{ item.curriculumName }}
                  </div>
                </div>
              </div>

              <div class="body">
                <div class="line">
                  <div class="l">售价</div>
                  <div class="r">
                    <div>
                      {{ item.priceItemDetail.priceName }}
                    </div>
                    <div style="color: var(--g6); margin-top: 4px">
                      ¥{{ item.priceItemDetail.price | formatNumber}} 包含{{ item.priceItemDetail.priceNum
                      }}{{ item.priceItemDetail.priceUnitName }}
                    </div>
                  </div>
                </div>

                <div class="line">
                  <div class="l">购买数量</div>
                  <div class="r">
                    {{ item.productQuantity }}
                  </div>
                </div>

                <div class="line" v-if="item.chargeType == 1">
                  <div class="l">赠送本课程({{ item.priceItemDetail.priceUnitName }})</div>
                  <div class="r">
                    {{ item.freeAmount || '-' }}
                  </div>
                </div>

                <div class="line">
                  <div class="l">直减或折扣</div>
                  <div class="r">
                    <template v-if="item.discountMoney">
                      <span v-if="judgeHasDiscount(item.discount)"
                        >{{ item.discount }}折&nbsp;&nbsp;</span
                      >
                      <span style="color: var(--c3)">-¥{{ item.discountMoney | formatNumber }}</span>
                    </template>
                    <template v-else> - </template>
                  </div>
                </div>

                <div class="line" v-if="item.chargeType == 1">
                  <div class="l">有效期至</div>
                  <div class="r">
                    <template v-if="item.feeExpireTime">
                      {{ item.feeExpireTime | formatDatetime('yyyy-MM-dd') }}
                    </template>
                    <template v-else> 不限 </template>
                  </div>
                </div>

                <div class="line" v-if="item.chargeType == 2">
                  <div class="l">计费时段</div>
                  <div class="r">
                    <template v-if="item.chargeRules && item.chargeRules.length > 0">
                      {{ item.chargeRules.map(rule=>{return `${app.tool.date.formatDatetime(rule.chargeStartTime, 'yyyy-MM-dd')}至${app.tool.date.formatDatetime(rule.chargeEndTime, 'yyyy-MM-dd')}`}).join(';') }}
                    </template>
                    <template v-else>
                      未设置
                    </template>
                  </div>
                </div>

                <div class="line" v-if="appscene == 'teacher'">
                  <div class="l">收费类型</div>
                  <div class="r fc">
                    {{ item.orderFlagName || '-' }}
                    <van-icon
                      name="edit"
                      class="editicon"
                      v-if="isShowEdit2"
                      @click.stop="updateSfType(item)"
                    />
                  </div>
                </div>

                <div class="line" v-if="appscene == 'teacher' && order.orderType == 0">
                  <div class="l">业绩归属人</div>
                  <div class="r fc">
                    {{ item.achievementBelongerList | getBelongerList() }}
                    <van-icon
                      name="edit"
                      class="editicon"
                      v-if="isShowEdit2"
                      @click.stop="updateBelonger(item)"
                    />
                  </div>
                </div>

                <div style="height: calc(var(--gap) * 6)"></div>
                <div class="line-hair van-hairline--top"></div>
                <div style="height: calc(var(--gap) * 6)"></div>

                <div class="line">
                  <div class="l"></div>
                  <div class="r fc" style="font-weight: 600" @click="popToast('项目金额')">
                    项目金额<van-icon name="question-o" class="tips-icon" /> ：¥{{
                      item.orderItemReceivableMoney | formatNumber
                    }}
                    <van-icon :name="item.toggle ? 'arrow-up' : 'arrow-down'" style="margin-left: 2px" @click.stop="item.toggle = !item.toggle"/>
                  </div>
                </div>

                <div class="expand-card" v-if="item.toggle">
                  <div class="expand-card-item">
                    <span @click="popToast('项目原价')" class="flex-center">项目原价<van-icon name="question-o" class="tips-icon" /></span>
                    <span>¥{{ item.totalMoney | formatNumber }}</span>
                  </div>
                  <div class="expand-card-item" v-if="item.discountMoney">
                    <span>直减或折扣</span>
                    <span class="red">-¥{{ item.discountMoney | formatNumber }}</span>
                  </div>
                  <!-- <div class="expand-card-item">
                    <span>优惠活动分摊金额</span>
                    <span class="red">-¥</span>
                  </div> -->
                  <div class="expand-card-item" v-if="getPointObj(item.orderItemPromotions)">
                    <span>积分抵扣分摊金额</span>
                    <span class="red">-¥{{getPointObj(item.orderItemPromotions).promotionMoney | formatNumber}}</span>
                  </div>
                </div>


                <div class="line" v-if="order.orderStatus == 1 && item.oweMoney > 0 && order.oweFee == 1">
                  <div class="l"></div>
                  <div class="r fc" style="font-weight: 600">
                    欠交金额：<span style="color: var(--c3)">¥{{ item.oweMoney | formatNumber }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 1.1.2、物品 -->
            <div class="b2" v-if="item.commodityType === 0" :key="item.id">
              <div class="head">
                <svg
                  class="vxm-icon l"
                  aria-hidden="true"
                  font-size="24"
                  style="margin-right: calc(var(--gap) * 8)"
                >
                  <use xlink:href="#vxm-icon-wupin"></use>
                </svg>

                <div class="r">
                  <div class="r1 van-ellipsis">
                    {{ item.productName }}
                  </div>
                  <div class="r2 van-ellipsis" v-if="item.priceItemDetail.commodityPriceType == 2">
                    {{ item.priceItemDetail.priceName }}
                  </div>
                </div>
              </div>
              <div class="body">
                <div class="line">
                  <div class="l">售价</div>
                  <div class="r">
                    ¥{{ item.priceItemDetail.price | formatNumber }}/{{ item.priceItemDetail.priceUnitName }}
                  </div>
                </div>

                <div class="line">
                  <div class="l">购买数量({{ item.priceItemDetail.priceUnitName }})</div>
                  <div class="r">
                    {{ item.productQuantity }}
                  </div>
                </div>

                <div class="line">
                  <div class="l">直减或折扣</div>
                  <div class="r">
                    <template v-if="item.discountMoney">
                      <span v-if="judgeHasDiscount(item.discount)"
                        >{{ item.discount }}折&nbsp;&nbsp;</span
                      >
                      <span style="color: var(--c3)">-¥{{ item.discountMoney | formatNumber }}</span>
                    </template>
                    <template v-else> - </template>
                  </div>
                </div>

                <div class="line" v-if="appscene == 'teacher' && order.orderType == 0">
                  <div class="l">业绩归属人</div>
                  <div class="r fc">
                    {{ item.achievementBelongerList | getBelongerList() }}
                    <van-icon
                      name="edit"
                      class="editicon"
                      v-if="isShowEdit2"
                      @click.stop="updateBelonger(item)"
                    />
                  </div>
                </div>

                <div style="height: calc(var(--gap) * 6)"></div>
                <div class="line-hair van-hairline--top"></div>
                <div style="height: calc(var(--gap) * 6)"></div>

                <div class="line">
                  <div class="l"></div>
                  <div class="r fc" style="font-weight: 600" @click="popToast('项目金额')">
                    项目金额<van-icon name="question-o" class="tips-icon" />：¥{{
                      item.orderItemReceivableMoney | formatNumber
                    }}
                    <van-icon :name="item.toggle ? 'arrow-up' : 'arrow-down'" style="margin-left: 2px" @click.stop="item.toggle = !item.toggle"/>
                  </div>
                </div>
                <div class="expand-card" v-if="item.toggle">
                
                <div class="expand-card-item">
                    <span @click="popToast('项目原价')" class="flex-center">项目原价<van-icon name="question-o" class="tips-icon" /></span>
                    <span>¥{{ item.totalMoney | formatNumber }}</span>
                  </div>
                  <div class="expand-card-item" v-if="item.discountMoney">
                    <span>直减或折扣</span>
                    <span class="red">-¥{{ item.discountMoney | formatNumber }}</span>
                  </div>
                  <!-- <div class="expand-card-item">
                    <span>优惠活动分摊金额</span>
                    <span class="red">-¥</span>
                  </div> -->
                  <div class="expand-card-item" v-if="getPointObj(item.orderItemPromotions)">
                    <span>积分抵扣分摊金额</span>
                    <span class="red">-¥{{getPointObj(item.orderItemPromotions).promotionMoney | formatNumber}}</span>
                  </div>
                </div>

                <div class="line" v-if="order.orderStatus == 1 && item.oweMoney > 0 && order.oweFee == 1">
                  <div class="l"></div>
                  <div class="r fc" style="font-weight: 600">
                    欠交金额：<span style="color: var(--c3)">¥{{ item.oweMoney | formatNumber }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 1.1.3、课时包 -->
            <div class="b2" v-if="item.commodityType === 4" :key="item.id">
              <div class="head">
                <div class="l cardtag">课时包</div>
                <!-- <svg
                  class="vxm-icon l"
                  aria-hidden="true"
                  font-size="24"
                  style="margin-right: calc(var(--gap) * 8)"
                >
                  <use v-if="item.commodityType === 1" xlink:href="#vxm-icon-banji"></use>
                  <use v-else-if="item.commodityType === 2" xlink:href="#vxm-icon-kecheng"></use>
                </svg> -->

                <div class="r">
                  <div class="r1 van-ellipsis">
                    {{ item.productName }}
                  </div>
                </div>
              </div>

              <div class="body">
                <div class="line">
                  <div class="l">售价</div>
                  <div class="r">
                    <div>
                      {{ item.priceItemDetail.priceName }}
                    </div>
                    <div style="color: var(--g6); margin-top: 4px">
                      ¥{{ item.priceItemDetail.price | formatNumber }} 包含{{ item.priceItemDetail.priceNum
                      }}{{ item.priceItemDetail.priceUnitName }}
                    </div>
                  </div>
                </div>

                <div class="line">
                  <div class="l">购买数量</div>
                  <div class="r">
                    {{ item.productQuantity }}
                  </div>
                </div>

                <div class="line" v-if="item.freeAmount > 0">
                  <div class="l">赠送本课时包({{ item.priceItemDetail.priceUnitName }})</div>
                  <div class="r">
                    {{ item.freeAmount || '-' }}
                  </div>
                </div>

                <div class="line">
                  <div class="l">直减或折扣</div>
                  <div class="r">
                    <template v-if="item.discountMoney">
                      <span v-if="judgeHasDiscount(item.discount)"
                        >{{ item.discount }}折&nbsp;&nbsp;</span
                      >
                      <span style="color: var(--c3)">-¥{{ item.discountMoney | formatNumber }}</span>
                    </template>
                    <template v-else> - </template>
                  </div>
                </div>

                <div class="line" v-if="item.chargeType == 1">
                  <div class="l">有效期至</div>
                  <div class="r">
                    <template v-if="item.feeExpireTime">
                      {{ item.feeExpireTime | formatDatetime('yyyy-MM-dd') }}
                    </template>
                    <template v-else> 不限 </template>
                  </div>
                </div>

                <div class="line" v-if="item.chargeType == 2">
                  <div class="l">计费时段</div>
                  <div class="r">
                    <template v-if="item.chargeRules && item.chargeRules.length > 0">
                      {{ item.chargeRules.map(rule=>{return `${app.tool.date.formatDatetime(rule.chargeStartTime, 'yyyy-MM-dd')}至${app.tool.date.formatDatetime(rule.chargeEndTime, 'yyyy-MM-dd')}`}).join(';') }}
                    </template>
                    <template v-else>
                      {{ item.feeExpireStartTime | formatDatetime('yyyy-MM-dd') }} 至
                      {{ item.feeExpireTime | formatDatetime('yyyy-MM-dd') }}
                    </template>
                  </div>
                </div>

                <div class="line" v-if="appscene == 'teacher'">
                  <div class="l">收费类型</div>
                  <div class="r fc">
                    {{ item.orderFlagName }}
                    <van-icon
                      name="edit"
                      class="editicon"
                      v-if="isShowEdit2"
                      @click.stop="updateSfType(item)"
                    />
                  </div>
                </div>

                <div class="line" v-if="appscene == 'teacher' && order.orderType == 0">
                  <div class="l">业绩归属人</div>
                  <div class="r fc">
                    {{ item.achievementBelongerList | getBelongerList() }}
                    <van-icon
                      name="edit"
                      class="editicon"
                      v-if="isShowEdit2"
                      @click.stop="updateBelonger(item)"
                    />
                  </div>
                </div>

                <div style="height: calc(var(--gap) * 6)"></div>
                <div class="line-hair van-hairline--top"></div>
                <div style="height: calc(var(--gap) * 6)"></div>

                <div class="line">
                  <div class="l"></div>
                  <div class="r fc" style="font-weight: 600" @click="popToast('项目金额')">
                    项目金额<van-icon name="question-o" class="tips-icon" /> ：¥{{
                      item.orderItemReceivableMoney | formatNumber
                    }}
                    <van-icon :name="item.toggle ? 'arrow-up' : 'arrow-down'" style="margin-left: 2px" @click.stop="item.toggle = !item.toggle"/>
                  </div>
                </div>

                <div class="expand-card" v-if="item.toggle">
                  <div class="expand-card-item">
                    <span @click="popToast('项目原价')" class="flex-center">项目原价<van-icon name="question-o" class="tips-icon" /></span>
                    <span>¥{{ item.totalMoney | formatNumber }}</span>
                  </div>
                  <div class="expand-card-item" v-if="item.discountMoney">
                    <span>直减或折扣</span>
                    <span class="red">-¥{{ item.discountMoney | formatNumber }}</span>
                  </div>
                  <!-- <div class="expand-card-item">
                    <span>优惠活动分摊金额</span>
                    <span class="red">-¥</span>
                  </div> -->
                  <div class="expand-card-item" v-if="getPointObj(item.orderItemPromotions)">
                    <span>积分抵扣分摊金额</span>
                    <span class="red">-¥{{getPointObj(item.orderItemPromotions).promotionMoney | formatNumber}}</span>
                  </div>
                </div>

                <div class="line" v-if="order.orderStatus == 1 && item.oweMoney > 0 && order.oweFee == 1">
                  <div class="l"></div>
                  <div class="r fc" style="font-weight: 600">
                    欠交金额：<span style="color: var(--c3)">¥{{ item.oweMoney | formatNumber }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 1.1.4、储值卡 -->
            <div class="b2" v-if="item.commodityType === 5" :key="item.id">
              <div class="head">
                <div class="l stored-tag">储值卡</div>
                <div class="r">
                  <div class="r1 van-ellipsis">
                    {{ item.productName }}
                  </div>
                </div>
              </div>

              <div class="body">
                <div class="line">
                  <div class="l">充值金额</div>
                  <div class="r">
                    ¥{{item.businessJson && item.businessJson.rechargeStoredCard
                      && item.businessJson.rechargeStoredCard.rechargeStoredCardItem
                      && item.businessJson.rechargeStoredCard.rechargeStoredCardItem.principalTotalMoney | formatNumber }}
                  </div>
                </div>
                <div class="line">
                  <div class="l">赠送金额</div>
                  <div class="r">
                    ¥{{ item.businessJson && item.businessJson.rechargeStoredCard 
                      && item.businessJson.rechargeStoredCard.rechargeStoredCardItem
                      && item.businessJson.rechargeStoredCard.rechargeStoredCardItem.giveTotalMoney | formatNumber }}
                  </div>
                </div>
                <div class="line" v-if="appscene == 'teacher'">
                  <div class="l">收费类型</div>
                  <div class="r fc">
                    {{ item.orderFlagName }}
                    <van-icon
                      name="edit"
                      class="editicon"
                      v-if="isShowEdit2"
                      @click.stop="updateSfType(item)"
                    />
                  </div>
                </div>
                <div class="line" v-if="appscene == 'teacher' && order.orderType == 0">
                  <div class="l">业绩归属人</div>
                  <div class="r fc">
                    {{ item.achievementBelongerList | getBelongerList() }}
                    <van-icon
                      name="edit"
                      class="editicon"
                      v-if="isShowEdit2"
                      @click.stop="updateBelonger(item)"
                    />
                  </div>
                </div>
                <div style="height: calc(var(--gap) * 6)"></div>
                <div class="line-hair van-hairline--top"></div>
                <div style="height: calc(var(--gap) * 6)"></div>
                <div class="line">
                  <div class="l"></div>
                  <div class="r fc" style="font-weight: 600">
                    充值金额：¥{{
                      item.orderItemReceivableMoney | formatNumber
                    }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>

        <!-- 1.2、预存订单 -->
        <template v-if="order.sourceType == 7">
          <!-- 预存订单学员 -->
          <div class="b1">
            <div class="l1">
              {{ order.buyerNameStr }}
            </div>
            <div class="l2">收费校区：{{ order.campusName }}</div>
          </div>

          <div class="separate"></div>

          <!-- 预存订单金额相关 -->
          <div class="vx-cell-groud">
            <div class="vx-cell van-hairline--bottom">
              <div>购买项目</div>
              <div class="r">
                {{ order.orderItems[0].productName }}
              </div>
            </div>
            <div class="vx-cell van-hairline--bottom">
              <div>预存金额</div>
              <div class="r">¥{{ order.orderReceivableMoney | formatNumber }}</div>
            </div>
          </div>
        </template>

        <div class="separate"></div>

        <!-- 预存、收费、转课订单金额相关 -->
        <div class="vx-cell-groud">
          <!-- <div class="vx-cell">
            <div></div>
            <div
              class="r"
              @click="popToast(`${order.sourceType == 7 ? '订单金额-预存' : '订单金额'}`)"
            >
              订单金额<van-icon name="question-o" class="tips-icon" />：
              <span style="font-size: var(--fs-md); line-height: var(--lh-md); font-weight: 600"
                >¥{{ order.orderReceivableMoney }}</span
              >
            </div>
          </div> -->

          <div class="vx-cell van-hairline--bottom">
            <!-- 储值卡充值不展示订单金额：问号及展开 -->
            <div
              class="l"
              @click="popToast(`${order.sourceType == 7 ? '订单金额-预存' : '订单金额'}`)"
              v-if="order.sourceType !== 10"
              >订单金额<van-icon name="question-o" class="tips-icon"/>
            </div>
            <div
              class="l"
              v-if="order.sourceType == 10"
              >订单金额</div>
            <div
              class="r"
              style="font-size: var(--fs-md); line-height: var(--lh-md); font-weight: 600"
            >
              ¥{{ order.orderReceivableMoney | formatNumber }}
              <van-icon :name="moneyToggle ? 'arrow-up' : 'arrow-down'" style="margin-left: 2px" @click.stop="moneyToggle = !moneyToggle" v-if="order.sourceType !== 10"/>
            </div>
          </div>

          <div class="expand-card" v-if="moneyToggle">
            <div class="expand-card-item">
              <span @click="popToast('项目总原价')" class="flex-center">项目总原价<van-icon name="question-o" class="tips-icon" /></span>
              <span>¥{{order.totalMoney | formatNumber}}</span>
            </div>
            <div class="expand-card-item" v-if="order.discountMoney">
              <span>直减或折扣合计</span>
              <span class="red">-¥{{order.discountMoney | formatNumber}}</span>
            </div>
            <!-- <div class="expand-card-item">
              <span>优惠活动分摊金额</span>
              <span class="red">-¥</span>
            </div> -->
            <div class="expand-card-item" v-if="getPointObj(order.orderPromotions)">
              <span>积分抵扣</span>
              <span class="red">-¥{{getPointObj(order.orderPromotions).promotionMoney | formatNumber}}</span>
            </div>
          </div>

          <div class="vx-cell van-hairline--bottom" v-if="order.orderType == 1">
            <div class="l">转入金额</div>
            <div class="r">¥{{ order.transferInMoney | formatNumber }}</div>
          </div>

          <template v-if="order.orderStatus != 0 && order.sourceType != 7">
            <div class="vx-cell van-hairline--bottom">
              <div class="l" @click="popToast('实付总额')">
                实付总额<van-icon name="question-o" class="tips-icon" />
              </div>
              <div class="r">¥{{ order.payFact | formatNumber }}</div>
            </div>

            <div class="vx-cell van-hairline--bottom" v-if="order.transferAndRefundMoney > 0">
              <div class="l" @click="popToast('退转结总额')">
                退转结总额<van-icon name="question-o" class="tips-icon" />
              </div>
              <div class="r">¥{{ order.transferAndRefundMoney | formatNumber }}</div>
            </div>

            <div class="vx-cell van-hairline--bottom" v-if="hasRealOwn">
              <div class="l" @click="popToast('欠交总额')">
                欠交总额<van-icon name="question-o" class="tips-icon" />
              </div>
              <div class="r" style="color: var(--c3)">
                ¥{{ order.oweMoney | formatNumber
                }}<span v-if="appscene == 'parent'" style="color: var(--tlc)" @click="gotoPayAll(1)"
                  >&nbsp;补交</span
                >
              </div>
            </div>
          </template>
        </div>

        <div class="separate"></div>

        <!-- 预存、收费、转课订单编号 -->
        <div class="vx-cell-groud b4">
          <template v-if="appscene == 'teacher'">
            <div class="vx-cell">
              <div>订单编号</div>
              <div class="r">
                {{ order.orderNo }}
              </div>
            </div>

            <div class="op-body" v-if="flag.op1">
              <div class="line">
                <div class="l">订单来源</div>
                <div class="r">
                  {{ order.sourceTypeName }}
                </div>
              </div>

              <div class="line">
                <div class="l">创建人</div>
                <div class="r">
                  {{ order.ordererName }}
                </div>
              </div>

              <div class="line">
                <div class="l">创建时间</div>
                <div class="r">
                  {{ order.createTime | formatDatetime('yyyy-MM-dd hh:mm:ss') }}
                </div>
              </div>

              <div class="line" v-if="hasRealOwn">
                <div class="l">下次补交日期</div>
                <div class="r">
                  {{
                    order.nextPayTime
                      ? app.tool.date.formatDatetime(order.nextPayTime, 'yyyy-MM-dd')
                      : '-'
                  }}
                  <van-icon
                    name="edit"
                    class="editicon"
                    v-if="isShowEdit"
                    @click.stop="updateNextPayTime"
                  />
                </div>
              </div>

              <div class="line" v-if="order.orderStatus == 2 && order.updateTime">
                <div class="l">取消订单时间</div>
                <div class="r">
                  {{ order.updateTime | formatDatetime('yyyy-MM-dd hh:mm:ss') }}
                </div>
              </div>

              <div class="line">
                <div class="l" @click="popToast(`备注`)">
                  备注<van-icon name="question-o" class="tips-icon" />
                </div>
                <div class="r">
                  {{ order.orderNotes || '-' }}
                  <van-icon
                    name="edit"
                    class="editicon"
                    v-if="isShowEdit"
                    @click.stop="updateNotes('orderNotes')"
                  />
                </div>
              </div>
              <div class="line">
                <div class="l" @click="popToast(`对外备注`)">
                  对外备注<van-icon name="question-o" class="tips-icon" />
                </div>
                <div class="r">
                  {{ order.buyerNotes || '-' }}
                  <van-icon
                    name="edit"
                    class="editicon"
                    v-if="isShowEdit"
                    @click.stop="updateNotes('buyerNotes')"
                  />
                </div>
              </div>
              <div class="line">
                <div class="l">
                  附件图片
                </div>
                <div class="r" style="color:var(--c1)" @click.stop="showImage">
                  {{ order.attach ? '查看' : '添加' }}
                  <van-icon
                    name="arrow"
                    class="editicon"
                    color="var(--g6)"                    
                  />
                </div>
              </div>
            </div>
            <div class="vx-cell-center van-hairline--top" @click="openFlag('op1')">
              <template v-if="flag.op1">
                <van-icon name="arrow-up" style="margin-right: 2px" />收起
              </template>
              <template v-else>
                <van-icon name="arrow-down" style="margin-right: 2px" />展开
              </template>
            </div>
          </template>

          <template v-if="appscene == 'parent'">
            <div class="op-body">
              <div class="line">
                <div class="l">订单编号</div>
                <div class="r">
                  {{ order.orderNo }}
                </div>
              </div>

              <div class="line">
                <div class="l">创建时间</div>
                <div class="r">
                  {{ order.createTime | formatDatetime('yyyy-MM-dd hh:mm:ss') }}
                </div>
              </div>

              <div class="line" v-if="hasRealOwn">
                <div class="l">下次补交日期</div>
                <div class="r">
                  {{
                    order.nextPayTime
                      ? app.tool.date.formatDatetime(order.nextPayTime, 'yyyy-MM-dd')
                      : '-'
                  }}
                </div>
              </div>

              <div class="line" v-if="order.orderStatus == 2 && order.updateTime">
                <div class="l">取消订单时间</div>
                <div class="r">
                  {{ order.updateTime | formatDatetime('yyyy-MM-dd hh:mm:ss') }}
                </div>
              </div>

              <div class="line">
                <div class="l">备注</div>
                <div class="r">
                  {{ order.buyerNotes || '-' }}
                </div>
              </div>
            </div>
          </template>
        </div>

        <!-- 预存、收费、转课订单电子合同老师端 -->
        <div class="vx-cell-groud b5"
          v-if="appscene == 'teacher' && app.tool.safeReadObjProp(app.teacher.user, 'companyInfoVo.companyAppOpenList').indexOf('CONTRACT') > -1 && order.sourceType !== 10">
          <div class="vx-cell">
            <div>电子合同</div>
            <div class="r">
              <span class="textbtn"
                @click="goToPreviewContract"
                v-if="order.contract && order.contract.contractNo && app.permission.op('create_contract')">查看合同({{order.contract.status == 1 ? '待签署' : order.contract.status == 2 ? '已签署' : '已失效'}})</span>
              <span class="textbtn"
                v-if="app.permission.op('create_contract')"
                @click="goToGenerateContract">{{ (order.contract && order.contract.contractNo) ? '重新生成' : '生成合同' }}</span> 
            </div>
          </div>
          <div class="op-body" v-if="flag.op4 && order.contract && order.contract.id">
            <div class="line">
              <div class="l">合同编号</div>
              <div class="r">
                {{ order.contract.contractNo }}
              </div>
            </div>
            <div class="line">
              <div class="l">创建人</div>
              <div class="r">
                {{ order.contract.operatorName }}
              </div>
            </div>
            <div class="line">
              <div class="l">生成时间</div>
              <div class="r">
                {{ order.contract.createTime | formatDatetime('yyyy-MM-dd hh:mm:ss') }}
              </div>
            </div>
            <div class="line">
              <div class="l">签署时间</div>
              <div class="r">
                {{ order.contract.signTime | formatDatetime('yyyy-MM-dd hh:mm:ss') }}
              </div>
            </div>
          </div>
          <div class="vx-cell-center van-hairline--top" v-if="order.contract && order.contract.id" @click="openFlag('op4')">
            <template v-if="flag.op4">
              <van-icon name="arrow-up" style="margin-right: 2px" />收起
            </template>
            <template v-else>
              <van-icon name="arrow-down" style="margin-right: 2px" />展开
            </template>
          </div>
        </div>
        <!-- 预存、收费、转课订单电子合同家长端 -->
        <div class="other-info" v-if="order.contract && order.contract.id && appscene == 'parent'">
          <div class="other-btn" @click="goToPreviewContract">
            <div class="l">电子合同</div>
            <div class="r pr">{{ order.contract.status == 1 ? '去签署' : '查看' }}</div>
          </div>
        </div>

        <!-- 预存、收费、转课订单支付记录 -->
        <div class="other-info" v-if="order.paymentGroupList && order.paymentGroupList.length > 0">
          <div class="other-btn" @click="openFlag('payList')">
            <div class="l">支付记录</div>
            <div class="r">
              <template v-if="flag.payList">
                <van-icon name="arrow-up" style="margin-right: 2px" />
              </template>
              <template v-else>
                <van-icon name="arrow-down" style="margin-right: 2px" />
              </template>
            </div>
          </div>

          <div v-show="flag.payList">
            <div class="other-wrap" v-for="item in order.paymentGroupList" :key="item.id">
              <div class="op-body">
                <div class="line">
                  <div class="l">支付时间</div>
                  <div class="r">
                    {{ formatPayTime(item) }}
                    <van-icon
                      name="edit"
                      class="editicon"
                      v-if="isShowEdit2 && item.paymentRecordList.some(pay=>pay.payMethod == 2) && app.permission.op('fee_charge_order_edit_time')"
                      @click.stop="updatePayTime(item)"
                    />
                  </div>
                </div>
                <div class="line van-hairline--bottom black">
                  <div class="l" @click="popToast('实付金额')">
                    实付金额
                    <van-icon name="question-o" class="tips-icon" />
                  </div>
                  <div class="r van-ellipsis">
                    ¥{{ item.money | formatNumber }}
                    <span
                      class="textbtn"
                      v-if="
                        (appscene == 'teacher' && app.permission.op('query_receipt')) ||
                        appscene == 'parent'
                      "
                      @click.stop="toReceipt(item.id)"
                      >查看收据</span
                    >
                  </div>
                </div>
                <!-- 支付记录 -->
                <div v-for="pitem in item.paymentRecordList" :key="pitem.id">
                  <!-- 处理支付记录首行的展示 -->
                  <template v-if="pitem.payMethod !== 3">
                    <div class="line">
                      <div class="l">{{ pitem.payMethodDesc }}</div>
                      <div class="r van-ellipsis">¥{{ pitem.money | formatNumber }}
                        <van-icon
                          name="edit"
                          class="editicon"
                          v-if="pitem.paymentAccountCustomRecords && pitem.paymentAccountCustomRecords.length && isShowEditAccount"
                          @click.stop="updateCustomAccount(pitem, item)"
                        />
                      </div>
                    </div>
                  </template>
                  <template v-else-if="pitem.payMethod == 3 && pitem.isFirst">
                    <div class="line">
                      <div class="l">{{ pitem.payMethodDesc }}</div>
                    </div>
                  </template>

                  <!-- 线下收款账户支付 -->
                  <template v-if="pitem.paymentAccountCustomRecords && pitem.paymentAccountCustomRecords.length">
                    <div class="line" style="padding-left:calc(var(--gap) * 16)" v-for="record in pitem.paymentAccountCustomRecords" :key="record.id">
                      <div class="l van-ellipsis">- {{record.name}}</div>
                      <div class="r">
                        <div class="van-ellipsis">¥{{record.money | formatNumber}}</div>
                      </div>
                    </div>
                  </template>
                  <!-- 储值卡支付 -->
                  <template v-if="pitem.payMethod == 3">
                    <div class="line">
                      <div class="l van-ellipsis" style="padding-left:calc(var(--gap) * 16)">{{ pitem.payMethodBizName }}</div>
                      <div class="r van-ellipsis">¥{{ pitem.money | formatNumber }}</div>
                    </div>
                    <div class="line" style="padding-left:calc(var(--gap) * 32)" v-for="record in pitem.paymentRecordDetails" :key="record.id">
                      <div class="l van-ellipsis">- {{record.moneyType==1?'本金':'赠送'}}</div>
                      <div class="r van-ellipsis">¥{{record.money | formatNumber}}</div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="separate"></div>
            </div>
          </div>
        </div>

        <!-- 收费、转课订单 各种记录 -->
        <template v-if="order.sourceType != 7">
          <!-- 转入记录 -->
          <div
            class="other-info"
            v-if="order.transferInOrderRelationDtos && order.transferInOrderRelationDtos.length > 0"
          >
            <div class="other-btn" @click="openFlag('transIn')">
              <div class="l">转入记录</div>
              <div class="r">
                <template v-if="flag.transIn">
                  <van-icon name="arrow-up" style="margin-right: 2px" />
                </template>
                <template v-else>
                  <van-icon name="arrow-down" style="margin-right: 2px" />
                </template>
              </div>
            </div>

            <div v-show="flag.transIn">
              <div
                class="other-wrap"
                v-for="item in order.transferInOrderRelationDtos"
                :key="item.id"
              >
                <div class="op-body">
                  <div class="line">
                    <div class="l">转出项目</div>
                    <div class="r van-ellipsis">
                      {{ item.transferOutName }}
                    </div>
                  </div>

                  <div class="line">
                    <div class="l" @click="popToast('转出数量')">
                      转出数量({{ item.priceUnitName }})
                      <van-icon name="question-o" class="tips-icon" />
                    </div>
                    <div class="r">
                      {{ item.transferCourseTotalAmount }}
                    </div>
                  </div>

                  <div class="line">
                    <div class="l">操作时间</div>
                    <div class="r">
                      {{ item.createTime | formatDatetime('yyyy-MM-dd hh:mm:ss') }}
                    </div>
                  </div>
                </div>
                <div class="separate"></div>
              </div>
            </div>
          </div>

          <!-- 转出记录：测试发现貌似这个数组中不会有值，先保留不动吧 -->
          <div
            class="other-info"
            v-if="
              order.transferOutOrderRelationDtos && order.transferOutOrderRelationDtos.length > 0
            "
          >
            <div class="other-btn" @click="openFlag('transOut')">
              <div class="l">转出记录</div>
              <div class="r">
                <template v-if="flag.transOut">
                  <van-icon name="arrow-up" style="margin-right: 2px" />
                </template>
                <template v-else>
                  <van-icon name="arrow-down" style="margin-right: 2px" />
                </template>
              </div>
            </div>

            <div v-show="flag.transOut">
              <div
                class="other-wrap"
                v-for="item in order.transferOutOrderRelationDtos"
                :key="item.id"
              >
                <div class="op-body">
                  <div class="line">
                    <div class="l">转入项目</div>
                    <div class="r van-ellipsis">
                      {{ item.transferInName }}
                    </div>
                  </div>

                  <div class="line">
                    <div class="l">转出项目</div>
                    <div class="r">
                      {{ item.transferOutName }}
                    </div>
                  </div>

                  <div class="line">
                    <div class="l" @click="popToast('转出数量')">
                      转出数量({{ item.priceItemDetail.priceUnitName }})
                      <van-icon name="question-o" class="tips-icon" />
                    </div>
                    <div class="r">
                      {{ item.transferCourseTotalAmount }}
                    </div>
                  </div>

                  <div class="line">
                    <div class="l">转出金额</div>
                    <div class="r">¥{{ item.transferMoney | formatNumber }}</div>
                  </div>
                  <div class="line">
                    <div class="l">操作时间</div>
                    <div class="r">
                      {{ item.createTime | formatDatetime('yyyy-MM-dd hh:mm:ss') }}
                    </div>
                  </div>
                </div>
                <div class="separate"></div>
              </div>
            </div>
          </div>

          <!-- 结转记录 -->
          <div
            class="other-info"
            v-if="order.transferRecordList && order.transferRecordList.length > 0"
          >
            <div class="other-btn" @click="openFlag('trans')">
              <div class="l">结转记录</div>
              <div class="r">
                <template v-if="flag.trans">
                  <van-icon name="arrow-up" style="margin-right: 2px" />
                </template>
                <template v-else>
                  <van-icon name="arrow-down" style="margin-right: 2px" />
                </template>
              </div>
            </div>
            <div v-show="flag.trans">
              <div
                class="other-wrap"
                v-for="item in order.transferRecordList"
                :key="item.refundOrderId"
              >
                <div class="op-body">
                  <div class="line">
                    <div class="l">结转项目</div>
                    <div class="r">
                      {{ item.productName }}
                    </div>
                  </div>

                  <div class="line" v-if="item.commodityType == 0">
                    <div class="l" @click="popToast('结转数量')">
                      结转数量({{ item.priceItemDetail.priceUnitName }})
                      <van-icon name="question-o" class="tips-icon" />
                    </div>
                    <div class="r">
                      {{ item.productQuantity }}
                    </div>
                  </div>

                  <div class="line" v-else-if="item.commodityType == 1 || item.commodityType == 2">
                    <div class="l" @click="popToast('结转数量')">
                      结转数量({{ item.priceUnitName }})
                      <van-icon name="question-o" class="tips-icon" />
                    </div>
                    <div class="r">
                      {{ item.totalAmount }}
                    </div>
                  </div>

                  <div class="line">
                    <div class="l">实际结转金额</div>
                    <div class="r">¥{{ item.realRefundMoney | formatNumber }}</div>
                  </div>
                  <div class="line">
                    <div class="l">操作时间</div>
                    <div class="r">
                      {{ item.refundTime | formatDatetime('yyyy-MM-dd hh:mm:ss') }}
                    </div>
                  </div>
                </div>
                <div class="separate"></div>
              </div>
            </div>
          </div>

          <!-- 退费记录 -->
          <div
            class="other-info"
            v-if="order.refundRecordList && order.refundRecordList.length > 0"
          >
            <div class="other-btn" @click="openFlag('refund')">
              <div class="l">退费记录</div>
              <div class="r">
                <template v-if="flag.refund">
                  <van-icon name="arrow-up" style="margin-right: 2px" />
                </template>
                <template v-else>
                  <van-icon name="arrow-down" style="margin-right: 2px" />
                </template>
              </div>
            </div>
            <div v-show="flag.refund">
              <div
                class="other-wrap"
                v-for="item in order.refundRecordList"
                :key="item.refundOrderId"
              >
                <div class="op-body">
                  <div class="line">
                    <div class="l">退费项目</div>
                    <div class="r">
                      {{ item.productName }}
                    </div>
                  </div>
                  <!-- commodityType0物品 -->
                  <div class="line" v-if="item.commodityType == 0">
                    <div class="l" @click="popToast('退费数量')">
                      退费数量({{ item.priceItemDetail.priceUnitName }})
                      <van-icon name="question-o" class="tips-icon" />
                    </div>
                    <div class="r">
                      {{ item.productQuantity }}
                    </div>
                  </div>
                  <!-- commodityType1班级，commodityType2课程 -->
                  <div class="line" v-else-if="item.commodityType == 1 || item.commodityType == 2">
                    <div class="l" @click="popToast('退费数量')">
                      退费数量({{ item.priceUnitName }})
                      <van-icon name="question-o" class="tips-icon" />
                    </div>
                    <div class="r">
                      {{ item.totalAmount }}
                    </div>
                  </div>

                  <div class="line">
                    <div class="l">实退金额</div>
                    <div class="r">¥{{ item.realRefundMoney | formatNumber }}</div>
                  </div>
                  <div class="line">
                    <div class="l">操作时间</div>
                    <div class="r">
                      {{ item.refundTime | formatDatetime('yyyy-MM-dd hh:mm:ss') }}
                    </div>
                  </div>
                </div>
                <div class="separate"></div>
              </div>
            </div>
          </div>

          <!-- 作废记录 -->
          <template v-if="appscene == 'teacher' && order.orderType == 0">
            <div class="other-info" v-if="order.orderStatus == 4">
              <div class="other-btn" @click="openFlag('op2')">
                <div class="l">作废记录</div>
                <div class="r">
                  <template v-if="flag.op2">
                    <van-icon name="arrow-up" style="margin-right: 2px" />
                  </template>
                  <template v-else>
                    <van-icon name="arrow-down" style="margin-right: 2px" />
                  </template>
                </div>
              </div>
              <div class="other-wrap" v-if="flag.op2">
                <div class="op-body">
                  <div class="line">
                    <div class="l">操作人</div>
                    <div class="r">
                      {{ order.invalidOperatorName }}
                    </div>
                  </div>
                  <div class="line">
                    <div class="l">操作时间</div>
                    <div class="r">
                      {{ order.invalidTime | formatDatetime('yyyy-MM-dd hh:mm:ss') }}
                    </div>
                  </div>
                </div>
                <div class="separate"></div>
              </div>
            </div>
          </template>
        </template>

        <!-- 查看编辑记录、订单作废 -->
        <template v-if="appscene == 'teacher'">
          <div class="separate"></div>

          <div class="footbtns">
            <div v-if="isShowEditRecordBtn" class="btn" @click="gotoEditRecord()">查看编辑记录</div>
            <div v-if="isShowLine" class="sepline">|</div>
            <!-- 订单作废 目前预存不支持作废-->
            <div
              v-if="isShowZfBtn"
              class="btn"
              data-test="order-detail-page-btn-toViod"
              @click="toVoidOrder()"
            >
              订单作废
            </div>
          </div>
        </template>
      </template>

      <!-- 2、非预存的退费、结转订单 -->
      <template
        v-if="
          appscene == 'teacher' &&
          (order.orderType == 2 || order.orderType == 3) &&
          order.sourceType != 9
        "
      >
        <!-- 非预存的退费、结转订单学员 -->
        <div class="b1">
          <div class="l1">{{ order.refunderNameStr }}</div>
          <div class="l2">
            {{ { 2: '退费', 3: '结转' }[order.orderType] }}校区：{{ order.campusName }}
          </div>
        </div>

        <!-- 非预存的退费、结转订单项目 -->
        <template v-for="item in order.refundOrderItems">
          <!-- 2.1、课程/班级 -->
          <div class="b2" v-if="item.commodityType === 1 || item.commodityType == 2" :key="item.id">
            <div class="head">
              <svg
                class="vxm-icon l"
                aria-hidden="true"
                font-size="24"
                style="margin-right: calc(var(--gap) * 8)"
              >
                <use v-if="item.commodityType === 1" xlink:href="#vxm-icon-banji"></use>
                <use v-else-if="item.commodityType === 2" xlink:href="#vxm-icon-kecheng"></use>
              </svg>

              <div class="r" v-if="item.commodityType === 1">
                <div class="r1 van-ellipsis">{{ item.productName }}</div>
                <div class="r2 van-ellipsis">
                  {{ item.curriculumName }}
                </div>
              </div>

              <div class="r" v-if="item.commodityType === 2">
                <div class="r1 van-ellipsis">
                  {{ item.curriculumName }}
                </div>
              </div>
            </div>

            <div class="body">
              <div class="line">
                <div class="l">原订单编号</div>
                <div class="r" @click="gotoOriginalOrder(item)">
                  {{ item.originalOrderNo }}&nbsp;&nbsp;<span style="color: var(--tlc)">查看</span>
                </div>
              </div>

              <div class="line">
                <div class="l" @click="popToast('计费单价')">
                  计费单价<van-icon name="question-o" class="tips-icon" />
                </div>
                <div class="r">
                  <!-- <div>¥{{ item.refundPrice | formatNumber }}/{{ item.priceItemDetail.priceUnitName }}</div> -->
                  <div>¥{{ item.refundPrice | formatNumber }}/{{ item.refundPriceUnitName }}</div>
                </div>
              </div>

              <div class="line">
                <div class="l">
                  {{ { 2: '退', 3: '结转' }[order.orderType] }}购买数量({{
                    // item.priceItemDetail.priceUnitName
                    item.refundPriceUnitName
                  }})
                </div>
                <div class="r">{{ item.courseAmount }}</div>
              </div>

              <div class="line" v-if="item.freeAmount">
                <div
                  class="l"
                  @click="popToast(`${{ 2: '退', 3: '结转' }[order.orderType]}赠送数量`)"
                >
                  {{ { 2: '退', 3: '结转' }[order.orderType] }}赠送数量({{
                    // item.priceItemDetail.priceUnitName
                    item.refundPriceUnitName
                  }})
                  <van-icon name="question-o" class="tips-icon" />
                </div>
                <div class="r">{{ item.freeAmount }}</div>
              </div>

              <div class="line">
                <div class="l">{{ { 2: '退费', 3: '结转' }[order.orderType] }}扣款</div>
                <div class="r" style="color: var(--c3)" v-if="item.otherDeductions">
                  -¥{{ item.otherDeductions | formatNumber }}
                </div>
                <div class="r" v-else>-</div>
              </div>

              <div class="line">
                <div class="l">{{ { 2: '退费', 3: '结转' }[order.orderType] }}溢价</div>
                <div class="r" style="color: var(--c3)" v-if="item.premiumMoney">
                  ¥{{ item.premiumMoney | formatNumber }}
                </div>
                <div class="r" v-else>-</div>
              </div>

              <div class="line" v-if="item.deductionPayMoney">
                <div class="l">冲减欠交金额</div>
                <div class="r" style="color: var(--c3)">
                  ¥{{ item.deductionPayMoney | formatNumber }}
                </div>
              </div>

              <div style="height: calc(var(--gap) * 6)"></div>
              <div class="line-hair van-hairline--top"></div>
              <div style="height: calc(var(--gap) * 6)"></div>

              <div class="line">
                <div class="l"></div>
                <div class="r" style="font-weight: 600">
                  项目{{ { 2: '应退', 3: '实际结转' }[order.orderType] }}金额：¥{{
                    item.realRefundMoney | formatNumber
                  }}
                </div>
              </div>
            </div>
          </div>

          <!-- 2.2、物品 -->
          <div class="b2" v-if="item.commodityType === 0" :key="item.id">
            <div class="head">
              <svg
                class="vxm-icon l"
                aria-hidden="true"
                font-size="24"
                style="margin-right: calc(var(--gap) * 8)"
              >
                <use xlink:href="#vxm-icon-wupin"></use>
              </svg>

              <div class="r">
                <div class="r1 van-ellipsis">{{ item.productName }}</div>
                <div class="r2 van-ellipsis" v-if="item.priceItemDetail.commodityPriceType == 2">
                  {{ item.priceItemDetail.priceName }}
                </div>
              </div>
            </div>

            <div class="body">
              <div class="line">
                <div class="l">原订单编号</div>
                <div class="r" @click="gotoOriginalOrder(item)">
                  {{ item.originalOrderNo }}&nbsp;&nbsp;<span style="color: var(--tlc)">查看</span>
                </div>
              </div>

              <div class="line">
                <div class="l">
                  {{ { 2: '退费', 3: '结转' }[order.orderType] }}数量({{
                    item.priceItemDetail.priceUnitName
                  }})
                </div>
                <div class="r">{{ item.productQuantity }}</div>
              </div>

              <div class="line" v-if="item.otherDeductions">
                <div class="l">{{ { 2: '退费', 3: '结转' }[order.orderType] }}扣款</div>
                <div class="r" style="color: var(--c3)">-¥{{ item.otherDeductions | formatNumber }}</div>
              </div>

              <div class="line" v-if="item.deductionPayMoney">
                <div class="l">冲减欠交金额</div>
                <div class="r" style="color: var(--c3)">
                  {{ item.deductionPayMoney | formatNumber }}
                </div>
              </div>

              <div style="height: calc(var(--gap) * 6)"></div>
              <div class="line-hair van-hairline--top"></div>
              <div style="height: calc(var(--gap) * 6)"></div>

              <div class="line">
                <div class="l"></div>
                <div class="r" style="font-weight: 600">
                  项目{{ { 2: '应退', 3: '结转' }[order.orderType] }}金额：¥{{
                    item.realRefundMoney | formatNumber
                  }}
                </div>
              </div>
            </div>
          </div>

          <!-- 2.3、课时包 -->
          <div class="b2" v-if="item.commodityType === 4" :key="item.id">
            <div class="head">
              <div class="l cardtag">课时包</div>
              <!-- <svg
                class="vxm-icon l"
                aria-hidden="true"
                font-size="24"
                style="margin-right: calc(var(--gap) * 8)"
              >
                <use v-if="item.commodityType === 1" xlink:href="#vxm-icon-banji"></use>
                <use v-else-if="item.commodityType === 2" xlink:href="#vxm-icon-kecheng"></use>
              </svg> -->

              <div class="r">
                <div class="r1 van-ellipsis">
                  {{ item.productName }}
                </div>
              </div>
            </div>

            <div class="body">
              <div class="line">
                <div class="l">原订单编号</div>
                <div class="r" @click="gotoOriginalOrder(item)">
                  {{ item.originalOrderNo }}&nbsp;&nbsp;<span style="color: var(--tlc)">查看</span>
                </div>
              </div>

              <div class="line">
                <div class="l">
                  {{ { 2: '退', 3: '结转' }[order.orderType] }}购买数量({{
                    item.priceItemDetail.priceUnitName
                  }})
                </div>
                <div class="r">{{ item.courseAmount }}</div>
              </div>

              <div class="line" v-if="item.freeAmount > 0">
                <div class="l" @click="popToast('赠送')">
                  {{ { 2: '退', 3: '结转' }[order.orderType] }}赠送数量({{
                    item.priceItemDetail.priceUnitName
                  }})
                  <van-icon name="question-o" class="tips-icon" />
                </div>
                <div class="r">{{ item.freeAmount }}</div>
              </div>

              <!-- <div class="line" v-if="item.freeAmount">
                <div
                  class="l"
                  @click="popToast(`${{ 2: '退', 3: '结转' }[order.orderType]}赠送数量`)"
                >
                  {{ { 2: '退', 3: '结转' }[order.orderType] }}赠送数量({{
                    item.priceItemDetail.priceUnitName
                  }})
                  <van-icon name="question-o" class="tips-icon" />
                </div>
                <div class="r">{{ item.freeAmount }}</div>
              </div> -->

              <div class="line">
                <div class="l">{{ { 2: '退费', 3: '结转' }[order.orderType] }}扣款</div>
                <div class="r" style="color: var(--c3)" v-if="item.otherDeductions">
                  -{{ item.otherDeductions | formatNumber}}
                </div>
                <div class="r" v-else>-</div>
              </div>

              <!-- <div class="line">
                <div class="l">{{ { 2: '退费', 3: '结转' }[order.orderType] }}溢价</div>
                <div class="r" style="color: var(--c3)" v-if="item.premiumMoney">
                  {{ item.premiumMoney }}
                </div>
                <div class="r" v-else>-</div>
              </div> -->

              <div class="line" v-if="item.deductionPayMoney">
                <div class="l">冲减欠交金额</div>
                <div class="r" style="color: var(--c3)">
                  {{ item.deductionPayMoney | formatNumber }}
                </div>
              </div>

              <div style="height: calc(var(--gap) * 6)"></div>
              <div class="line-hair van-hairline--top"></div>
              <div style="height: calc(var(--gap) * 6)"></div>

              <div class="line">
                <div class="l"></div>
                <div class="r" style="font-weight: 600">
                  项目{{ { 2: '应退', 3: '实际结转' }[order.orderType] }}金额：¥{{
                    item.realRefundMoney | formatNumber
                  }}
                </div>
              </div>
            </div>
          </div>

          <!-- 2.4、储值卡 -->
          <div class="b2" v-if="item.commodityType === 5" :key="item.id">
            <div class="head">
              <div class="l stored-tag">储值卡</div>
              <div class="r"><div class="r1 van-ellipsis">{{ item.productName }}</div></div>
            </div>

            <div class="body">
              <div class="line">
                <div class="l">退费金额</div>
                <div class="r">{{ item.refundMoney | formatNumber }}</div>
              </div>
              <div class="line" style="padding-left:calc(var(--gap) * 16)">
                <div class="l">- 退本金</div>
                <div class="r">{{(item.businessJson && item.businessJson.storedCardPrincipalMoney) | formatNumber }}</div>
              </div>
              <div class="line" style="padding-left:calc(var(--gap) * 16)">
                <div class="l">- 退赠送</div>
                <div class="r">{{(item.businessJson && item.businessJson.storedCardGiveMoney) | formatNumber }}</div>
              </div>
              <div class="line">
                <div class="l">退费扣款</div>
                <div class="r" style="color: var(--c3)" v-if="item.otherDeductions">
                  -¥{{ item.otherDeductions | formatNumber }}
                </div>
                <div class="r" v-else>-</div>
              </div>
            </div>
          </div>
        </template>

        <div class="separate"></div>

        <!-- 非预存的退费、结转订单金额相关 -->
        <div class="vx-cell-groud">
          <div class="vx-cell">
            <div></div>
            <div>
              <div class="r" @click="popToast(`总${{ 2: '退费', 3: '结转' }[order.orderType]}金额`)">
                总{{ { 2: '退费', 3: '结转' }[order.orderType] }}金额<van-icon
                  name="question-o"
                  class="tips-icon"
                />：
                <span style="font-size: var(--fs-md); line-height: var(--lh-md); font-weight: 600"
                  >¥{{ order.realRefundMoney | formatNumber }}</span
                >
              </div>
              <!-- 退费的金额 -->
              <div class="r"  
                style="margin-top: 10px"
                v-if="hasOnlineRefund"            
                @click="popToast('实退金额')">
                实退金额<van-icon name="question-o" class="tips-icon"/>：
                <span style="font-size: var(--fs-md); line-height: var(--lh-md); font-weight: 600">
                  <template v-if="onlineRefundStatus !== 2">
                    ¥{{ Number(((order.realRefundMoney * 1000 - onlineRefundMoney * 1000) / 1000).toFixed(2))  }}
                  </template>
                  <template v-else>
                    ¥{{ order.realRefundMoney | formatNumber }}
                  </template>
                </span>              
              </div>            
              <!-- 退款中,退款失败 -->
              <div class="r" v-if="hasOnlineRefund && onlineRefundStatus !== 2" style="margin-top: 10px">
                {{onlineRefundStatus == 1 ? '退款中' : '退款失败'}}：
                <span style="font-size: var(--fs-md); line-height: var(--lh-md); font-weight: 600">
                  ¥{{ onlineRefundMoney | formatNumber }}
                </span>              
              </div>
            </div>
          </div>          
        </div>

        <div class="separate"></div>

        <!-- 非预存的退费、结转订单编号 -->
        <div class="vx-cell-groud b4">
          <div class="vx-cell">
            <div>订单编号</div>
            <div class="r">
              {{ order.refundOrderNo }}
            </div>
          </div>
          <div class="op-body" v-if="flag.op1">
            <div class="line">
              <div class="l">创建人</div>
              <div class="r">
                {{ order.operatorName }}
              </div>
            </div>
            <div class="line"  v-if="order.orderType == 2">
              <div class="l">创建时间</div>
              <div class="r">
                {{ order.createTime | formatDatetime('yyyy-MM-dd hh:mm:ss') }}
              </div>
            </div>
            <div class="line" v-if="order.orderType == 3">
              <div class="l">结转时间</div>
              <div class="r">
                {{ order.createTime | formatDatetime('yyyy-MM-dd hh:mm:ss') }}
              </div>              
            </div>

            <!-- <div class="line">
              <div class="l">{{ { 2: '退费', 3: '结转' }[order.orderType] }}时间</div>
              <div class="r" v-if="order.orderType == 3">
                {{ order.createTime | formatDatetime('yyyy-MM-dd hh:mm:ss') }}
              </div>
              <div class="r" v-else-if="order.orderType == 2">
                {{ order.refundTime | formatDatetime('yyyy-MM-dd') }}
                <van-icon
                  name="edit"
                  class="editicon"
                  v-if="appscene == 'teacher' && app.permission.op('order_detail_edit_time')"
                  @click.stop="updateRefundTime(order)"
                />
              </div>
            </div> -->

            <div class="line" v-if="order.orderType == 3">
              <div class="l">结转方式</div>
              <div class="r">
                结转入电子钱包
              </div>
            </div>
            <!-- <div class="line">
              <div class="l">{{ { 2: '退费', 3: '结转' }[order.orderType] }}方式</div>
              <div class="r">                
                {{ { 2: '其他线下方式', 3: '结转入电子钱包' }[order.orderType] }}
              </div>
            </div> -->

            <!-- <div class="line" v-if="order.paymentRecordDetailList && order.paymentRecordDetailList.length">
              <div class="l">线下退款账户</div>
              <div class="r">
                <div class="van-ellipsis">
                  <div v-for="record in order.paymentRecordDetailList" :key="record.paymentAccountCustomId">
                    {{record.name}}：{{record.money}}
                  </div>
                </div>
                <van-icon
                  name="edit"
                  class="editicon"
                  v-if="isShowEditAccount"
                  @click.stop="updateCustomAccount2()"
                />
              </div>
            </div> -->
            <div class="line">
              <div class="l">备注</div>
              <div class="r">
                {{ order.remark || '-' }}
                <!-- 退费备注修改 -->
                <van-icon
                    name="edit"
                    class="editicon"
                    v-if="isShowEdit"
                    @click.stop="updateNotesRefund('remark')"
                  />
              </div>
            </div>
          </div>
          <div class="vx-cell-center van-hairline--top" @click="openFlag('op1')">
            <template v-if="flag.op1">
              <van-icon name="arrow-up" style="margin-right: 2px" />收起
            </template>
            <template v-else>
              <van-icon name="arrow-down" style="margin-right: 2px" />展开
            </template>
          </div>
        </div>

        <!-- 非预存的退费、结转订单退款记录 -->
        <template v-if="order.orderType == 2">
          <div class="other-info">
            <div class="other-btn" @click="openFlag('op3')">
              <div class="l">退款记录</div>
              <div class="r">
                <template v-if="flag.op3">
                  <van-icon name="arrow-up" style="margin-right: 2px" />
                </template>
                <template v-else>
                  <van-icon name="arrow-down" style="margin-right: 2px" />
                </template>
              </div>
            </div>
            <div class="other-wrap" v-show="flag.op3">
              <div class="op-body" v-if="!hasOnlineRefund || order.offlineRefundMoney > 0">
                <div class="line">
                  <div class="l">退款时间</div>
                  <div class="r">
                    {{ order.normalOfflineRefundTime | formatDatetime('yyyy-MM-dd') }}
                    <van-icon
                      name="edit"
                      class="editicon"
                      v-if="appscene == 'teacher' && app.permission.op('order_detail_edit_time')"
                      @click.stop="updateRefundTime(order, 'normalOfflineRefundTime')"
                    />
                  </div>
                </div>
                <div class="line">
                  <div class="l">线下退款</div>
                  <div class="r">
                    ¥{{ order.offlineRefundMoney | formatNumber }}
                    <van-icon
                      name="edit"
                      class="editicon"
                      v-if="isShowEditAccount && order.paymentRecordDetailList && order.paymentRecordDetailList.length"
                      @click.stop="updateCustomAccount2()"
                    />
                  </div>                  
                </div>
                <template v-if="order.paymentRecordDetailList && order.paymentRecordDetailList.length">
                  <div class="line" style="padding-left:calc(var(--gap) * 16)" v-for="record in order.paymentRecordDetailList" :key="record.paymentAccountCustomId">
                    <div class="l">- {{record.name}}</div>
                    <div class="r">
                      <div class="van-ellipsis">¥{{record.money | formatNumber}}</div>
                    </div>
                  </div>
                </template>
              </div>

              <div class="separate" v-if="hasOnlineRefund && order.onlineRefundMoney > 0 && order.offlineRefundMoney > 0" ></div>
              <div class="op-body" v-if="hasOnlineRefund && order.onlineRefundMoney > 0">
                <div class="line">
                  <div class="l">退款时间</div>
                  <div class="r">
                    {{ order.onlineRefundTime | formatDatetime('yyyy-MM-dd hh:mm:ss') }}
                  </div>
                </div>
                <div class="line">
                  <div class="l">线上退款</div>
                  <div class="r">
                    ¥{{ order.onlineRefundMoney | formatNumber }}
                  </div>
                </div>
                <div class="line" v-if="hasOnlineRefund && onlineRefundStatus !== 2">
                  <div class="r" v-if="onlineRefundStatus == 1" style="color: var(--c4)">
                    退款中
                  </div>
                  <div class="r" v-else  style="color: var(--c3)">
                    退款失败：{{ order.onlineRefundRecordDto.failReason }}
                  </div>
                </div>
              </div>

              <div class="separate" v-if="order.transferOfflineRefundMoney > 0 && order.offlineRefundMoney > 0"></div>
              <!-- 转线下的 -->
              <div class="op-body" v-if="order.transferOfflineRefundMoney > 0">
                <div class="line">
                  <div class="l">退款时间</div>
                  <div class="r">
                    {{ order.transferOfflineRefundTime | formatDatetime('yyyy-MM-dd') }}                    
                    <van-icon
                      name="edit"
                      class="editicon"
                      v-if="appscene == 'teacher' && app.permission.op('order_detail_edit_time')"
                      @click.stop="updateRefundTime(order, 'transferOfflineRefundTime')"
                    />
                  </div>
                </div>
                <div class="line">
                  <div class="l">线下退款</div>
                  <div class="r">
                    ¥{{ order.transferOfflineRefundMoney | formatNumber }}
                    <van-icon
                      name="edit"
                      class="editicon"
                      v-if="isShowEditAccount"
                      @click.stop="updateCustomAccount3()"
                    />
                  </div>                  
                </div>
                <template v-if="order.paymentRecordDetailOfflineList && order.paymentRecordDetailOfflineList.length">
                  <div class="line" style="padding-left:calc(var(--gap) * 16)" v-for="record in order.paymentRecordDetailOfflineList" :key="record.paymentRecordDetailOfflineList">
                    <div class="l">{{record.name}}</div>
                    <div class="r">
                      <div class="van-ellipsis">¥{{record.money | formatNumber }}</div>
                    </div>
                  </div>
                </template>
              </div>
            </div>

            <!-- 重试线上退款和转线下退款 -->
            <div class="op-body" v-if="order.enableRetryOnlineRefund || order.enableSwitchOfflineRefund">
              <div class="line" style="line-height: 40px">
                <div style="flex: 1; padding: 0 12px">
                  <van-button 
                    v-if="order.enableRetryOnlineRefund && app.permission.op('on_line_order_refund')"
                    @click.stop="retryRefund"                    
                    square round block
                    type="primary"
                    size="normal"
                    class="btn">
                    重试线上退款
                  </van-button>                 
                </div>
                <div style="flex: 1; padding: 0 12px">
                  <van-button 
                    v-if="order.enableSwitchOfflineRefund && app.permission.op('refund_order || refund_card')"
                    @click.stop="refundTransferOffline"
                    size="normal"
                    square round block
                    type="primary"                    
                    class="btn">
                    转线下退款
                  </van-button>
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>

      <!-- 2.1、预存退费订单 -->
      <template v-if="appscene == 'teacher' && order.orderType == 2 && order.sourceType == 9">
        <!-- 预存退费订单学员 -->
        <div class="b1">
          <div class="l1">{{ order.refunderNameStr }}</div>
          <div class="l2">退费校区：{{ order.campusName }}</div>
        </div>

        <div class="separate"></div>

        <!-- 预存退费订单金额相关 -->
        <div class="vx-cell-groud">
          <div class="vx-cell van-hairline--bottom">
            <div>退费项目</div>
            <div class="r">{{ order.refundOrderItems[0].productName }}</div>
          </div>
          <div class="vx-cell van-hairline--bottom">
            <div>退款金额</div>
            <div class="r">¥{{ order.refundMoney | formatNumber }}</div>
          </div>
          <div class="vx-cell">
            <div></div>
            <div class="r">
              <span>实退金额：</span>
              <span style="font-size: var(--fs-md); line-height: var(--lh-md); font-weight: 600"
                >¥{{ order.realRefundMoney | formatNumber }}</span
              >
            </div>
          </div>
        </div>

        <div class="separate"></div>

        <!-- 预存退费订单编号 -->
        <div class="vx-cell-groud b4">
          <div class="vx-cell">
            <div>订单编号</div>
            <div class="r">
              {{ order.refundOrderNo }}
            </div>
          </div>
          <div class="op-body" v-if="flag.op1">
            <div class="line">
              <div class="l">创建人</div>
              <div class="r">
                {{ order.operatorName }}
              </div>
            </div>

            <div class="line">
              <div class="l">退费时间</div>
              <div class="r">
                {{ order.refundTime | formatDatetime('yyyy-MM-dd') }}
                <van-icon
                  name="edit"
                  class="editicon"
                  v-if="appscene == 'teacher' && app.permission.op('order_detail_edit_time')"
                  @click.stop="updateRefundTime(order)"
                />
              </div>
            </div>

            <div class="line">
              <div class="l">退费方式</div>
              <div class="r">其他线下方式</div>
            </div>

            <div class="line" v-if="order.paymentRecordDetailList && order.paymentRecordDetailList.length">
              <div class="l">线下退款账户</div>
              <div class="r">
                <div class="van-ellipsis">
                  <div v-for="record in order.paymentRecordDetailList" :key="record.paymentAccountCustomId">
                    {{record.name}}：{{record.money | formatNumber}}
                  </div>
                </div>
                <van-icon
                  name="edit"
                  class="editicon"
                  v-if="isShowEditAccount"
                  @click.stop="updateCustomAccount2()"
                />
              </div>
            </div>
            

            <div class="line">
              <div class="l">备注</div>
              <div class="r">
                {{ order.remark || '-' }}
                 <!-- 退费备注修改 -->
                 <van-icon
                    name="edit"
                    class="editicon"
                    v-if="isShowEdit"
                    @click.stop="updateNotesRefund('remark')"
                  />
              </div>
            </div>
          </div>
          <div class="vx-cell-center van-hairline--top" @click="openFlag('op1')">
            <template v-if="flag.op1">
              <van-icon name="arrow-up" style="margin-right: 2px" />收起
            </template>
            <template v-else>
              <van-icon name="arrow-down" style="margin-right: 2px" />展开
            </template>
          </div>
        </div>
      </template>

      <div class="separate"></div>
    </div>

    <!-- 底部按钮 -->
    <div class="page-foot" v-if="appscene == 'teacher'">
      <div class="btns">
        <van-button
          v-if="order.orderStatus == 0 && app.permission.op('cancel_order')"
          class="btn1"
          square
          round
          block
          @click.stop="cancelOrder(order)"
        >
          取消订单
        </van-button>
        <van-button
          v-if="hasRealOwn && app.permission.op('payment_order')"
          class="btn1"
          square
          round
          block
          type="primary"
          @click.stop="toCollectMoney()"
          >收款</van-button
        >
      </div>
    </div>

    <div class="page-foot" v-else-if="appscene == 'parent'">
      <div class="tips" v-if="order.paying && order.paying.payExpireRemainTime">
        <div v-if="parentPayTipsText">{{ parentPayTipsText }}</div>
        <!-- <van-count-down
          class="formattime"
          :time="order.paying.payExpireRemainTime"
          :format="formatDownTime(order.paying.payExpireRemainTime, 1)"
          @finish="countDownFinish"
        /> -->
      </div>
      <div class="btns">
        <van-button
          v-if="hasRealOwn"
          class="btn1"
          square
          round
          block
          type="primary"
          @click.stop="gotoPay()"
        >
          {{ parentPayText }}
        </van-button>
        <van-button
          v-if="scene == 1"
          class="btn1"
          square
          round
          data-test="order-detail-page-btn-goMall"
          @click="gotoMallHome"
          >返回商城
        </van-button>
      </div>
    </div>
    <image-list ref="image" :isEdit="isShowEdit"></image-list>
    <custom-account ref="customAccount"></custom-account>
    <return-account-popup ref="returnAccount" v-if="appscene == 'teacher'"></return-account-popup>

    <!-- 1、弹窗选择当前订单使用的合同模板 -->
    <van-dialog
      v-model="contractTemplateShow"
      title="请选择当前订单使用的合同模板："
      confirm-button-text="确定"
      show-cancel-button
      class="od-contract-template-choose-dialog"
      :beforeClose="confirmOrderContract">
      <div class="wrapper">
        <van-radio-group v-model="contractTemplateId">
          <van-radio :name="item.id" v-for="item in contractTemplateList" :key="item.id">{{item.name}}</van-radio>
        </van-radio-group>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import imageList from '@x3/vue/comp/image-list.vue';
import customAccount from '@teacher/views/sf/popup/custom-account-popup.vue';
import returnAccountPopup from '@teacher/views/base/agreed-return/child/return-account-popup-1.vue';
let pageTitles = {
  0: '收费详情',
  1: '转课详情',
  2: '退费详情',
  3: '结转详情',
};

export default {
  name: 'x3-order-detail',
  props: {
    appscene: {
      type: String,
      default: 'teacher',
    },
  },
  components:{
    imageList,
    customAccount,
    returnAccountPopup,
  },
  data() {
    return {
      pageTitle: this.appscene == 'parent' ? '订单详情' : pageTitles[this.$route.params.orderType],
      // 订单ID
      orderInfoId: this.$route.params.id,
      // 订单类型: 0收费，1转课，2退费，3结转
      orderType: this.$route.params.orderType,
      // 订单来源：0:商城，1:前台收费，2:老生录入，3:退费，4:转课转入收费，5:转课转出退费，6:商城会员积分-物品，7:钱包预存，9:预存退费，10:储值卡充值
      sourceType: this.$route.params.sourceType,
      // 请求后台获取到的订单信息
      order: {},

      //进入的场景：1：商城支付完成后跳转进入
      scene: this.$route.query.scene,
      moneyToggle: false,
      hasCustom: false,
      // 控制展开，收起
      flag: {
        op1: false,
        op2: false,
        op3: false,
        op4: false,
        payList: false,
        transIn: false,
        transOut: false,
        trans: false,
        refund: false,
      },
      // 是否展示订单选择合同模板
      contractTemplateShow: false,
      // 合同模板列表
      contractTemplateList: [],
      contractTemplateId: '',
    };
  },
  computed: {
    ...Vuex.mapState(['lessonUnit']),
    popMsg() {
      let lessonUnit = this.lessonUnit
      return {
        项目原价: '项目原价=项目售价*数量',
        项目总原价: '所有项目的售价*购买数量之和',
        项目金额: '售价*购买数量-直减或折扣-活动优惠分摊金额-积分抵扣分摊金额',
        订单金额: '项目原价-直减或折扣-优惠活动-积分抵扣',
        退转结总额: '退费总额+结转总额+转课（转出）总额之和',
        欠交总额: '所有项目“欠交金额”之和',
        实付金额: '钱包抵扣金额+线上/线下支付金额',
        实付总额: '每条支付记录“实付金额”之和',
        转出数量: '转出数量=转出购买数量+转出赠送数量',
        结转数量: '结转数量=结转购买数量+结转赠送数量',
        退费数量: '退费数量=退购买数量+退赠送数量',
        退赠送数量: '赠送数量不计算费用',
        计费单价: `已课消${lessonUnit}数和剩余未课消${lessonUnit}数的计费单价（如学员以优惠价8元/${lessonUnit}购买，退费时需按原价10元/${lessonUnit}对已课消的${lessonUnit}数进行计费）`,
        总退费金额: '所有项目应退金额之和',
        结转赠送数量: '赠送数量不计算费用',
        总结转金额: '所有项目结转金额之和',
        备注: '不需要家长知悉的备注信息，本机构老师可在订单详情中查看，家长端订单详情不展示',
        对外备注: '需要家长知悉的备注信息，家长和本机构老师均可在订单详情中查看',
        赠送: '赠送不计算费用',
        实退金额: '包含线下退款和线上退款金额',
      };
    },
    // 是否有久交
    hasRealOwn() {
      let or = this.order;
      return or.oweFee == 1 && or.orderStatus < 2 && or.oweMoney > 0;
    },
    parentPayTipsText() {
      let paying = this.order.paying,
        str = '';
      // 本次实付￥100，其中钱包将抵扣￥90，还需再补交￥10，
      if (paying && paying.paymentRecordList.length == 2) {
        str = `本次实付￥${paying.money}，其中`;
        paying.paymentRecordList.forEach(item => {
          if (item.payMethod == 0) {
            str += `钱包将抵扣￥${item.money}，`;
          } else if (item.payMethod == 1) {
            str += `还需再补交￥${item.money}。`;
          }
        });
      }
      return str;
    },
    parentPayText() {
      let text = '';
      if (this.order.hasPay == 1) {
        text = '补交 ';
      } else {
        text = '支付 ';
      }
      if (this.order.paying) {
        this.order.paying.paymentRecordList.forEach(item => {
          if (item.payMethod == 1) {
            text += `￥${app.tool.formatNumber(item.money)}`;
          }
        });
      }
      return text;
    },
    // 未付款时不允许编辑的项目用这个
    isShowEdit2() {
      let or = this.order;
      return (
        app.permission.op('edit_order') &&
        (or.orderType == 0 || or.orderType == 1) &&
        or.orderStatus == 1
      );
    },
    isShowEdit() {
      let or = this.order;
      return (
        app.permission.op('edit_order') &&
        (
          ( (or.orderType == 0 || or.orderType == 1) && (or.orderStatus == 0 || or.orderStatus == 1) )
          ||
          ( or.orderType == 2 )
        )
      );
    },
    isShowEditAccount(){
      return this.hasCustom && app.permission.op('edit_order');
    },
    // 是否展示“查看编辑记录”按钮
    isShowEditRecordBtn() {
      return true;
    },
    // 是否展示“订单作废”按钮，
    isShowZfBtn() {
      let or = this.order;
      // 作废目前只支持收费订单，且预存订单也不支持。
      return (
        or.orderType == 0 &&
        or.sourceType != 7 &&
        or.orderStatus === 1 &&
        app.permission.op('invalid_order')
      );
    },
    // 是否在下方订单作废与查看编辑记录那里展示分隔线
    isShowLine() {
      return this.isShowEditRecordBtn && this.isShowZfBtn;
    },

    // 是否有线上原路退款
    hasOnlineRefund(){
      return this.order.orderType == 2 && this.order.onlineRefundMoney > 0 && this.order.onlineRefundRecordDto && this.order.onlineRefundRecordDto.method == 1;
    },    
    // 线上原路退款的状态
    onlineRefundStatus(){
      return this.hasOnlineRefund && this.order.onlineRefundRecordDto.status;
    },
    // 线上原路退款的金额
    onlineRefundMoney(){
      return this.hasOnlineRefund && this.order.onlineRefundRecordDto.realRefundMoney;
    }

  },
  filters: {
    formatNumber(v) {
      return app.tool.formatNumber(v);
    },
    // 业绩归属人 展示格式化
    getBelongerList(list = []) {
      let teachers = list.map(tc => {
        let str = tc.teacherName;
        if (tc.scaleStr) {
          str += ` ${tc.scaleStr}%`;
        }
        return str;
      });
      return teachers.join('、') || '-';
    },
  },
  methods: {
    getPointObj(list){
      if (list) {
        return list.find(pro=>pro.promotionType === 'POINT');
      }
    },

    async showImage(){
      const obj = await this.$refs.image.open(this.order.attach || {list:[]});
      this.showLoading();
      await this.$api.editOrderNotesAndNextPayTime({
        studentId: this.order.studentId,
        orderId: this.orderInfoId,
        type: 5,
        attach: obj,
      });
      vant.Toast.clear();
      this.emitUpdateEvent();
    },
    async render(isSetTitle = true) {
      if (this.orderType == 0 || this.orderType == 1) {
        if (this.sourceType == 7) {
          await this.getPrestoreOrder();
        } else {
          await this.getOrderData();
        }
      } else if (this.orderType == 2 || this.orderType == 3) {
        await this.getOrderRefundDetail();
      }
      if (app.permission.op('edit_order') && this.appscene == 'teacher') {
        this.getAccList();
      }
      if (isSetTitle) {
        app.tool.setDocTitle(this.pageTitle);
      }
    },
    // 获取收费、转课订单详情
    async getOrderData() {
      let api = this.$api.orderInfoGet;
      if (this.appscene == 'parent') {
        api = this.$api.getParentOrderInfo;
      }
      let res = await api({
        orderInfoId: this.orderInfoId,
      });
      res.data.orderItems = res.data.orderItems.map(item=>{
        item.toggle = false;
        return item;
      })
      let isFirst = false;
      res.data.paymentGroupList = res.data.paymentGroupList.map(item=>{
        item.paymentRecordList.map(v=> {
          if (v.payMethod == 3) {
            if (!isFirst) {
              v.isFirst = true;
              isFirst = true;
            } else {
              v.isFirst = false;
            }
          }
          return v;
        })
        return item;
      })
      this.order = res.data;
    },
    // 获取预存订单详情
    async getPrestoreOrder() {
      let api = this.$api.orderInfoGet;
      if (this.appscene == 'parent') {
        api = this.$api.getParentOrderInfo;
      }
      let res = await api({
        orderInfoId: this.orderInfoId,
      });

      this.order = res.data;
    },
    // 获取退费订单详情
    async getOrderRefundDetail() {
      let api = this.$api.getOrderRefundDetail;
      if (this.appscene == 'parent') {
        api = this.$api.getParentOrderRefundDetail;
      }
      let res = await api({
        orderRefundId: this.orderInfoId,
      });

      this.order = res.data;
    },
    // 倒计时格式化
    formatDownTime(time, type) {
      let str = '';
      if (time > 86400000) {
        str = 'DD天HH小时';
      } else if (time > 3600000) {
        str = 'HH小时mm分';
      } else {
        str = 'mm分钟ss秒';
      }
      if (type == 0) {
        if (this.appscene == 'teacher') {
          return `订单将在${str}后自动关闭，请提醒学员及时付款`;
        } else {
          return `订单将在${str}后自动关闭，请及时付款`;
        }
      } else if (type == 1) {
        return `${this.parentPayTipsText}本次支付将在${str}后自动关闭，请及时付款。`;
      }
    },
    // 倒计时完成刷新页面
    countDownFinish() {
      this.render();
    },
    // 支付记录中的支付时间格式化。主要是当有线下付款时，只取到天。
    formatPayTime(item) {
      let formatEG = 'yyyy-MM-dd hh:mm:ss';
      item.paymentRecordList.forEach(payitem => {
        if (payitem.payMethod == 2) {
          formatEG = 'yyyy-MM-dd';
        }
      });
      return app.tool.date.formatDatetime(item.payTime, formatEG);
    },
    // 判断是否有折扣
    judgeHasDiscount(discount) {
      if (discount === undefined || discount === null || discount === '') {
        return false;
      } else {
        return true;
      }
    },
    // 展开、收起
    openFlag(key) {
      this.flag[key] = !this.flag[key];
    },

    async retryRefund(){
      await vant.Dialog.confirm({
        title: '提示',
        message: '退款金额将直接退回家长支付账户，且无法撤销。请确认是否重试？',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
      this.showLoading('正在重新发起退款');
      const res = await this.$api.refundByRefundOrder({
        refundOrderId: this.order.id
      }).finally(()=>{
        vant.Toast.clear()
      });
      if (res.code == 200 && res.data) {
        this.render();
      }
    },

    // 转线下
    async refundTransferOffline(){
      const order = this.order;
      const result = await this.$refs.returnAccount.open({
          orderId: order.id,
          cdate: new Date(), 
          oweMoney: order.onlineRefundMoney,
          campusId: order.campusId,
      });
      this.showLoading();
      const res = await this.$api.refundTransferOffline({
        paymentRecordDetailList: result.paymentRecordDetailList.filter(item=>item.checked),
        refundOrderId: order.id
      }).finally(()=> {
        vant.Toast.clear();
      });
      if (res.code == 200) {
        this.render();
        this.$refs.returnAccount.show = false;
      }
    },

    // 老师端去收款
    toCollectMoney() {
      this.$router.push(`/sf2/${this.orderInfoId}`);
    },
    // 家长端支付
    gotoPay(isall) {
      // 如果存在挂起的支付，则支付这一笔；如果没有，则支付剩余金额
      let paying = this.order.paying,
        allPay = paying && paying.id ? 0 : 1;
      this.gotoPayAll(allPay);
    },
    // 家长端全款补交
    gotoPayAll(isAll) {
      app.parent.pay(this.orderInfoId, isAll);
    },
    // 跳转到原订单
    gotoOriginalOrder(item) {
      let orderId = item.originalOrderId,
        orderType = item.originalOrderType,
        sourceType = item.originalOrderSourceType;

      this.$router.push(`/orderDetail/${orderId}/${orderType}/${sourceType}`);
    },

    // 取消订单
    async cancelOrder(item) {
      await vant.Dialog.confirm({
        title: '提示',
        message: '取消订单学员将不能继续支付，是否确定取消',
        confirmButtonText: '是',
        cancelButtonText: '否',
      });
      let res = await this.$api.cancelOrder({
        companyId: item.companyId,
        id: item.id,
        orderItems: item.orderItems,
        sourceType: item.sourceType,
        studentId: item.studentId,
        parentChildId: item.parentChildId,
      });
      this.$toast.success('取消成功');
      this.emitUpdateEvent();
    },

    // 查看收据
    toReceipt(paymentGroupId) {
      this.$router.push(`/receipt?orderId=${this.orderInfoId}&paymentGroupId=${paymentGroupId}`);
    },
    // 返回商城
    gotoMallHome() {
      this.$router.push(`/mall/${this.order.companyId}`);
    },
    // 查看编辑记录
    gotoEditRecord() {
      this.$router.push(`/orderDetail/editRecord/${this.orderInfoId}`);
    },
    // 订单作废
    async toVoidOrder() {
      if (this.sourceType != 0) {
        await this.$dialog.confirm({
          title: '提示',
          confirmButtonText: '作废',
          confirmButtonColor: 'var(--c3)',
          message: `作废订单仅用于对录入错误的订单进行撤销操作，作废后将撤销此订单产生的收入、就读记录等，系统不会进行退款。`,
        });

        let ret = await this.$api.orderInfoInvalidOrder({
          orderInfoId: this.orderInfoId,
          studentId: this.order.studentId,
        });
        if (ret.code == 200) {
          this.emitUpdateEvent();
          vant.Toast.success('作废成功');
        } else if (ret.code == 830000023) {
          vant.Dialog.alert({
            message: '订单关联物品已发货，请前往物品销售/发货功能修改发货记录后再进行订单作废。',
          });
        } else if (ret.code == 830000034) {
          vant.Dialog.alert({
            message: '订单的支付记录已确认入账，无法作废订单。',
          });
        }
      } else {
        //商城订单
        this.$dialog.alert({
          title: '提示',
          message: '商城订单无法作废，若订单有误，请直接操作退费',
          confirmButtonText: '我知道了',
          confirmButtonColor: 'var(--g8)',
        });
      }
    },

    // 气泡提示
    popToast(name) {
      let key = `${name}`;

      vant.Toast({
        message: this.popMsg[key],
        duration: 0,
        overlay: true,
        closeOnClick: true,
        closeOnClickOverlay: true,
      });
    },

    async getAccList() {
      let res = await this.$api.getPaymentAccountList({
        campusId: this.order.campusId,
      });
      this.accounts = res.data;
      if (res.data.offlineCustomAccount) {
        this.paymentRecordDetailList = res.data.offlineCustomAccount.map(item => {
          return {
            name: item.name,
            paymentAccountCustomId: item.id,
            money: '',
            checked: false,
          };
        });
        this.hasCustom = res.data.hasCustom;
      }
    },

    updateCustomAccount(item, group){
      const map = {};
      item.paymentAccountCustomRecords.forEach(record=>{
        map[record.paymentAccountCustomId] = record.money;
      })
      const paymentRecordDetailList = this.paymentRecordDetailList.map(r=>{
        const record = JSON.parse(JSON.stringify(r));
        if (record.paymentAccountCustomId in map) {
          record.money = map[record.paymentAccountCustomId];
          record.checked = true;
        }
        return record;
      })

      this.$refs.customAccount
        .open({
          type: 'order',
          cdate: item.payTime,
          paymentRecordDetailList,
          oweMoney: item.money,
        })
        .then(async ({ paymentRecordDetailList }) => {
          await this.$api.editOrderCustomAccount({
            orderId: +this.orderInfoId,
            paymentGroupId: group.id,
            paymentRecordDetailList: paymentRecordDetailList.filter(d=>d.checked),
            paymentRecordId: item.id,
          });
          this.$refs.customAccount.show = false;
          vant.Toast('修改成功');
          this.emitUpdateEvent();
        })
    },
    updateCustomAccount2(){
      const map = {};
      this.order.paymentRecordDetailList.forEach(record=>{
        map[record.paymentAccountCustomId] = record.money;
      })
      const paymentRecordDetailList = this.paymentRecordDetailList.map(r=>{
        const record = JSON.parse(JSON.stringify(r));
        if (record.paymentAccountCustomId in map) {
          record.money = map[record.paymentAccountCustomId];
          record.checked = true;
        }
        return record;
      })

      this.$refs.customAccount
        .open({
          type: this.orderType == 2 ? 'tf' : 'order',          
          paymentRecordDetailList,
          oweMoney: this.order.normalOfflineRefundMoney,
        })
        .then(async ({ paymentRecordDetailList }) => {
          await this.$api.editOrderRefundCustomAccount({
            fromType: 1,
            orderRefundId: +this.orderInfoId,
            paymentRecordDetailList: paymentRecordDetailList.filter(d=>d.checked),
          });
          this.$refs.customAccount.show = false;
          vant.Toast('修改成功');
          this.emitUpdateEvent();
        })
    },
    updateCustomAccount3(){
      const map = {};
      this.order.paymentRecordDetailOfflineList.forEach(record=>{
        map[record.paymentAccountCustomId] = record.money;
      })
      const paymentRecordDetailList = this.paymentRecordDetailList.map(r=>{
        const record = JSON.parse(JSON.stringify(r));
        if (record.paymentAccountCustomId in map) {
          record.money = map[record.paymentAccountCustomId];
          record.checked = true;
        }
        return record;
      })

      this.$refs.customAccount
        .open({
          type: 'tf',          
          paymentRecordDetailList,
          oweMoney: this.order.transferOfflineRefundMoney,
        })
        .then(async ({ paymentRecordDetailList }) => {
          await this.$api.editOrderRefundCustomAccount({
            fromType: 2,
            orderRefundId: +this.orderInfoId,
            paymentRecordDetailList: paymentRecordDetailList.filter(d=>d.checked),
          });
          this.$refs.customAccount.show = false;
          vant.Toast('修改成功');
          this.emitUpdateEvent();
        })
    },
    // 编辑收费类型
    async updateSfType(item) {
      if (this.order.contract && this.order.contract.contractNo && app.tool.safeReadObjProp(app.teacher.user, 'companyInfoVo.companyAppOpenList').indexOf('CONTRACT') > -1) {
        await vant.Dialog.confirm({
          title: '提示',
          messageAlign: 'left',
          confirmButtonText: '确定',
          message: `修改订单信息，合同内容不会更新。如需更新合同内容，请 重新生成 电子合同。<br>确定继续修改？`,
        })
      }
      let res = await app.x3.side.xsSfType({
        id: item.orderFlagId,
        config: {
          must: true,
        },
      });
      await this.$api.editOrderFlag({
        studentId: this.order.studentId,
        orderId: this.orderInfoId,
        orderItemId: item.id,
        orderFlagId: res.id,
      });
      this.emitUpdateEvent();
    },
    // 编辑支付时间
    async updatePayTime(item) {
      if (this.order.contract && this.order.contract.contractNo && app.tool.safeReadObjProp(app.teacher.user, 'companyInfoVo.companyAppOpenList').indexOf('CONTRACT') > -1) {
        await vant.Dialog.confirm({
          title: '提示',
          messageAlign: 'left',
          confirmButtonText: '确定',
          message: `修改订单信息，合同内容不会更新。如需更新合同内容，请 重新生成 电子合同。<br>确定继续修改？`,
        })
      }
      let res = await app.x3.picker.calendar({
        defaultDate: new Date(item.payTime),
        minDate: new Date(2020, 1, 1),
        maxDate: new Date(),
      });
      const payObj = item.paymentRecordList.find(record=>record.payMethod == 2);
      await this.$api.editPayTime({
        orderId: this.orderInfoId,
        payTime: res.getTime(),
        paymentRecordId: payObj && payObj.id,
      })
      this.emitUpdateEvent();
    },    
    // 编辑退费时间
    async updateRefundTime(order, keyName = 'normalOfflineRefundTime') {
      if (this.order.contract && this.order.contract.contractNo && app.tool.safeReadObjProp(app.teacher.user, 'companyInfoVo.companyAppOpenList').indexOf('CONTRACT') > -1) {
        await vant.Dialog.confirm({
          title: '提示',
          messageAlign: 'left',
          confirmButtonText: '确定',
          message: `修改订单信息，合同内容不会更新。如需更新合同内容，请 重新生成 电子合同。<br>确定继续修改？`,
        })
      }
      let res = await app.x3.picker.calendar({
        defaultDate: new Date(order.refundTime),
        minDate: new Date(2020, 1, 1),
        maxDate: new Date(order.createTime),
      });
      await this.$api.editRefundTime({
        orderRefundId: this.orderInfoId,
        [keyName]: res.getTime(),
      })
      this.emitUpdateEvent();
    },    
    
    // 编辑关联意向
    async updateClue() {
      if (this.order.contract && this.order.contract.contractNo && app.tool.safeReadObjProp(app.teacher.user, 'companyInfoVo.companyAppOpenList').indexOf('CONTRACT') > -1) {
        await vant.Dialog.confirm({
          title: '提示',
          messageAlign: 'left',
          confirmButtonText: '确定',
          message: `修改订单信息，合同内容不会更新。如需更新合同内容，请 重新生成 电子合同。<br>确定继续修改？`,
        })
      }
      let clue = this.order.intentionClue;
      let newClue = await app.x3.side.xsStudentClues({
        id: (clue && clue.id) || '',
        config: {
          enableAdd: true,
        },
        params: {
          containIntentionClueId: (clue && clue.id) || '',
          studentId: this.order.studentId,
        },
      });

      await vant.Dialog.confirm({
        title: '提示',
        messageAlign: 'left',
        message: '修改关联意向后，原关联意向状态变更为跟进中',
        confirmButtonText: '确认修改',
      });

      await this.$api.updateOrderIntentionClue({
        campusId: this.order.campusId,
        studentId: this.order.studentId,
        orderId: this.orderInfoId,
        intentionClueId: newClue ? newClue.id : '',
      });
      this.emitUpdateEvent();
    },

    // 编辑业绩归属人
    async updateBelonger(item) {
      if (this.order.contract && this.order.contract.contractNo && app.tool.safeReadObjProp(app.teacher.user, 'companyInfoVo.companyAppOpenList').indexOf('CONTRACT') > -1) {
        await vant.Dialog.confirm({
          title: '提示',
          messageAlign: 'left',
          confirmButtonText: '确定',
          message: `修改订单信息，合同内容不会更新。如需更新合同内容，请 重新生成 电子合同。<br>确定继续修改？`,
        })
      }
      let res = await app.x3.side.xsBelonger({
        info: item,
        list: item.achievementBelongerList,
      });
      await this.$api.achievementEdit({
        studentId: this.order.studentId,
        orderId: this.orderInfoId,
        orderItemId: item.id,
        teacherAchievementItems: res,
      });
      this.emitUpdateEvent();
    },
    // 编辑下次补交日期或内外备注
    async update(params) {
      if (this.order.contract && this.order.contract.contractNo && app.tool.safeReadObjProp(app.teacher.user, 'companyInfoVo.companyAppOpenList').indexOf('CONTRACT') > -1) {
        await vant.Dialog.confirm({
          title: '提示',
          messageAlign: 'left',
          confirmButtonText: '确定',
          message: `修改订单信息，合同内容不会更新。如需更新合同内容，请 重新生成 电子合同。<br>确定继续修改？`,
        })
      }
      await this.$api.editOrderNotesAndNextPayTime({
        studentId: this.order.studentId,
        orderId: this.orderInfoId,
        ...params,
      });
      this.emitUpdateEvent();
    },
    // 编辑下次补交日期
    async updateNextPayTime() {
      if (this.order.contract && this.order.contract.contractNo && app.tool.safeReadObjProp(app.teacher.user, 'companyInfoVo.companyAppOpenList').indexOf('CONTRACT') > -1) {
        await vant.Dialog.confirm({
          title: '提示',
          messageAlign: 'left',
          confirmButtonText: '确定',
          message: `修改订单信息，合同内容不会更新。如需更新合同内容，请 重新生成 电子合同。<br>确定继续修改？`,
        })
      }
      let res = await app.x3.picker.calendar({
        defaultDate: this.order.nextPayTime ? new Date(this.order.nextPayTime) : new Date(),
        maxDate: new Date(2030, 12, 31),
      });
      let nextPayTime = res.getTime();
      await this.update({
        type: 2,
        nextPayTime: nextPayTime,
      });
    },
    // 编辑对内外备注
    async updateNotes(key) {
      if (this.order.contract && this.order.contract.contractNo && app.tool.safeReadObjProp(app.teacher.user, 'companyInfoVo.companyAppOpenList').indexOf('CONTRACT') > -1) {
        await vant.Dialog.confirm({
          title: '提示',
          messageAlign: 'left',
          confirmButtonText: '确定',
          message: `修改订单信息，合同内容不会更新。如需更新合同内容，请 重新生成 电子合同。<br>确定继续修改？`,
        })
      }
      let title = '',
        place = '',
        type = '';
      if (key == 'orderNotes') {
        title = '编辑备注';
        place = '请输入备注，仅本机构老师可见';
        type = 3;
      } else if (key == 'buyerNotes') {
        title = '编辑对外备注';
        place = '请输入对外备注，学员、家长和本机构老师均可见';
        type = 4;
      }

      let res = await app.x3.side.xsApprovalOpinion({
        config: {
          pageTitle: title,
        },
        field: {
          prop: 'reason',
          type: 'textarea',
          defaultValue: this.order[key],
          attrs: {
            placeholder: place,
            showWordLimit: true,
            maxlength: 500,
            rows: 4,
            inputAlign: 'left',
            clearable: true,
          },
        },
      });

      await this.update({
        type: type,
        [key]: res.reason,
      });
    },
    // 编辑退费备注
    async updateNotesRefund(key) {
      let title = '编辑备注',
        place = '请输入备注';
      let res = await app.x3.side.xsApprovalOpinion({
        config: {
          pageTitle: title,
        },
        field: {
          prop: 'reason',
          type: 'textarea',
          defaultValue: this.order[key],
          attrs: {
            placeholder: place,
            showWordLimit: true,
            maxlength: 500,
            rows: 4,
            inputAlign: 'left',
            clearable: true,
          },
        },
      });
      await this.$api.editRefundRemark({
        orderRefundId: this.order.id,
        remark:res.reason,
      });
      this.emitUpdateEvent();
    },
    emitUpdateEvent() {
      app.vue.$emit('update-order-detail-success');
    },
    // 查看合同按钮
    goToPreviewContract(){
      this.$router.push(
        this.appscene == 'parent' ? 
        `/contractPreview?contractId=${this.order.contract.id}&companyId=${this.order.companyId}` :
        `/contractPreview?contractId=${this.order.contract.id}`
      );
    },
    // 生成合同按钮
    goToGenerateContract(){
      if (this.order.contract && this.order.contract.status == 2) { // 签署状态 1待签署 2已签署 3已失效	
        vant.Dialog.confirm({
          title: '提示',
          message: `合同已签署，重新生成后上一份合同将失效，新生成的合同需要再次签署。<br>确认重新生成？`,
        }).then(res => {
          if (res === 'confirm') {
            this.toElectronicContract();
          }
        })
        .catch(err => {
          console.log(err);
        });
      } else {
        this.toElectronicContract();
      }
    },
    // 生成合同按钮-获取模板列表
    async toElectronicContract() {
      this.showLoading();
      let ret = await this.$api.contractTemplateList({
        campusIds: [this.order.campusId],
        page: {
          pageNum: 1,
          pageSize: 9999
        }
      });
      vant.Toast.clear();
      this.contractTemplateList = ret.data;
      // 该校区没有合同模板：提示没有模板
      if (this.contractTemplateList.length == 0) {
        vant.Dialog.confirm({
          message: '未设置合同模板，请先联系客服进行导入。\n导入完成后，可在【订单管理】中生成合同。',
          messageAlign: 'left',
          confirmButtonText: '我知道了',
          allowHtml: true,
          showCancelButton: true,
          cancelButtonText: '联系客服'
        }).catch(() => {
          this.toKefu();
        });
        return;
      } else if (this.contractTemplateList.length == 1) { // 该校区只有一份适用的模板：直接生成
        this.createOrderContract(this.contractTemplateList[0].id);
      } else { // 该校区有多份适用的合同模板：弹出提示，用户选一份模板生成合同
        this.contractTemplateId = '';
        this.contractTemplateShow = true;
      }
    },
    // 生成合同按钮-选择模板生成电子合同
    confirmOrderContract(action, done) {
      if (action === 'confirm') {
        if (!this.contractTemplateId) {
          this.$toast('请选择当前订单使用的合同模板');
          done(false);
          return;
        }
        this.createOrderContract(this.contractTemplateId);
        done();
      } else {
        done();
      }
    },
    // 生成合同按钮-确定生成合同
    async createOrderContract(tplId) {
      this.showLoading();
      let ret = await this.$api.createContract({
        isReCreate: (this.order.contract && this.order.contract.contractNo) ? 1 : 0, // 是否重新生成 0生成合同 1重新生成
        orderId: this.order.id,
        templateId: tplId
      });
      vant.Toast.clear();
      if (ret.code == 200) {
        this.emitUpdateEvent();
        this.$router.push(`/contractPreview?contractId=${ret.data.id}`);
      } else {
        this.$toast.fail(ret.msg);
      }
    },
    toKefu() {
      let realname = app.teacher.user.name,
        partnerid = app.teacher.user.id,
        uname = `云校-${app.teacher.user.companyInfoVo.companyName}`,
        tel = app.teacher.user.phone,
        companyId = app.teacher.user.companyInfoVo.id,
        customer_fields = encodeURIComponent(JSON.stringify({customField4: companyId})),
        kefuUrl = `https://xiaogj.sobot.com/chat/h5/v6/index.html?sysnum=2b52e6f7a8f0461cb188501e07b63bfd&channelid=4&realname=${realname}&partnerid=${partnerid}&uname=${uname}&tel=${tel}&customer_fields=${customer_fields}&groupid=d643054d3fd24933932718b9313e7b0e`;

      app.x3.popup.systemKefu(
        Object.assign({
          kefuUrl: kefuUrl
        })
      ).then(res=> {});
    }
  },
  created() {
    // 这里判断订单类型，是为了兼容老版本的微信推送订单（当时没有订单类型）
    if (!this.$route.params.orderType) {
      this.$router.replace('/orderList');
    } else {
      this.render();
      this.$onBus('update-order-detail-success', (obj) => {
        this.render(obj ? obj.isSetTitle : true);
      });
    }
  },

  beforeDestroy() {
    vant.Toast.clear();
  },
};
</script>

<style lang="scss" scoped>
.x3-order-detail-page {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .page-body {
    flex: 1;
    overflow: auto;
  }
  .page-foot {
    background: var(--white);
    .tips {
      padding-top: calc(var(--gap) * 4);
      padding-left: calc(var(--gap) * 16);
      padding-right: calc(var(--gap) * 16);
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
      color: var(--g6);
      text-align: center;
      // .formattime {
      //   font-size: var(--fs-md);
      //   line-height: var(--lh-md);
      //   color: var(--c3);
      //   text-align: center;
      // }
    }
    .btns {
      padding: 0 calc(var(--gap) * 8);
      display: flex;
      .btn1 {
        flex: 1;
        margin: calc(var(--gap) * 3) calc(var(--gap) * 8);
      }
    }
  }
}

.top-bg {
  padding: calc(var(--gap) * 18) calc(var(--gap) * 16) 0;
  height: calc(var(--w) * 100);
  color: var(--white);
  background: var(--c1);
  display: flex;
  &.gray {
    background: var(--g5);
  }
  .l {
    margin-right: calc(var(--gap) * 8);
  }
  .r {
    .r1 {
      font-size: var(--fs-ex1);
      line-height: var(--lh-ex1);
    }
    .r2 {
      padding-top: calc(var(--gap) * 2);
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
      opacity: 0.8;
      display: flex;
      .count-down-text {
        color: var(--white);
        font-size: var(--fs-sm);
        line-height: var(--lh-sm);
      }
    }
  }
}
.b1 {
  margin-top: -18px;
  margin-left: calc(var(--gap) * 16);
  margin-right: calc(var(--gap) * 16);
  padding: calc(var(--gap) * 16);
  border-radius: 8px;
  background: var(--white);
  overflow: hidden;
  .l1 {
    color: var(--g8);
    font-size: var(--fs-lg);
    line-height: var(--lh-lg);
    font-weight: 600;
  }
  .l2 {
    margin-top: calc(var(--gap) * 6);
    color: var(--g6);
    font-size: var(--fs-md);
    line-height: var(--lh-md);
  }
}
.b2 {
  margin-top: calc(var(--gap) * 12);
  margin-left: calc(var(--gap) * 16);
  margin-right: calc(var(--gap) * 16);
  border-radius: 8px;
  background: var(--white);
  overflow: hidden;
  .head {
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
    background: rgba(var(--g2-rgb), 0.3);
    display: flex;
    align-items: center;
    .l {
      margin-right: calc(var(--gap) * 8);
      flex: none;
      &.cardtag {
        height: 24px;
        padding: 0 calc(var(--gap) * 2);
        color: var(--white);
        background: var(--c1);
        display: flex;
        align-items: center;
      }
      &.stored-tag {
        height: 24px;
        padding: 0 calc(var(--gap) * 2);
        color: var(--white);
        background: var(--c3);
        display: flex;
        align-items: center;
      }
    }
    .r {
      flex: 1;
      overflow: hidden;
      .r1 {
        color: var(--g8);
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        font-weight: 600;
      }
      .r2 {
        margin-top: calc(var(--gap) * 6);
        color: var(--g6);
        font-size: var(--fs-md);
        line-height: var(--lh-md);
      }
    }
  }
  .body {
    padding: calc(var(--gap) * 6) calc(var(--gap) * 16);
    .line {
      padding: calc(var(--gap) * 6) 0;
      display: flex;
      justify-content: space-between;
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      .l {
        margin-right: calc(var(--gap) * 12);
        display: flex;
        align-items: center;
        color: var(--g6);
      }
      .r {
        flex: 1;
        // display: flex;
        // align-items: center;
        // justify-content: flex-end;
        color: var(--g7);
        text-align: right;
        .editicon {
          color: var(--c1);
          padding-left: calc(var(--gap) * 4);
          padding-top: calc(var(--gap) * 4);
          padding-bottom: calc(var(--gap) * 4);
        }
        &.fc {
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
      }
    }
  }
}
.expand-card {
  background: var(--g1);
  color: var(--g6);
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
  padding: 16px 12px;
  border-radius: 4px;
  margin-bottom: 12px;
  .expand-card-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:not(:last-child){
      margin-bottom: 12px;
    }
    .red {
      color: var(--c3);
    }
  }
}

.vx-cell-groud {
  padding: 0 calc(var(--gap) * 16);
  color: var(--g6);
  font-size: var(--fs-md);
  line-height: var(--lh-md);
  background: var(--white);
  border-bottom: 1px solid transparent;
  .vx-cell {
    padding: calc(var(--gap) * 16) 0;
    display: flex;
    justify-content: space-between;
    .l {
      display: flex;
      align-items: center;
    }
    .r {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: var(--g7);
      text-align: right;
    }
  }
  .vx-cell-center {
    padding: calc(var(--gap) * 16) 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &.b5 {
    margin-top: calc(var(--gap) * 12);
    .textbtn {
      margin-left: calc(var(--gap) * 16);
      color: var(--tlc);
    }
  }
}

.other-info {
  .other-btn {
    padding: 0 calc(var(--gap) * 16);
    height: calc(var(--w) * 36);
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--g6);
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    .pr {
      color: var(--c1);
    }
  }
  .other-wrap {
    background: var(--white);
    .op-body {
      padding: 0 calc(var(--gap) * 16);
    }
  }
}

.footbtns {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--fs-md);
  line-height: var(--lh-md);
  color: var(--tlc);
  .btn {
    padding: calc(var(--gap) * 5);
    text-decoration: underline;
  }
  .sepline {
    padding: 0 8px;
  }
}

.op-body {
  padding: calc(var(--gap) * 6) 0;
}

.b1,
.op-body {
  .line {
    padding: calc(var(--gap) * 6) 0;
    display: flex;
    justify-content: space-between;
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    &.black {
      .l,
      .r {
        color: var(--g8);
        font-weight: bold;
      }
    }
    .l {
      width: 120px;
      display: flex;
      align-items: center;
      margin-right: calc(var(--gap) * 12);
      color: var(--g6);
      flex: 0 0 auto;
    }
    .r {
      overflow: hidden;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: var(--g7);
      text-align: right;
      .editicon {
        color: var(--c1);
        padding-left: calc(var(--gap) * 4);
        padding-top: calc(var(--gap) * 4);
        padding-bottom: calc(var(--gap) * 4);
      }
      .textbtn {
        margin-left: calc(var(--gap) * 4);
        color: var(--tlc);
      }
    }
  }
}
.od-contract-template-choose-dialog {
  .wrapper {
    padding: 14px;
    max-height: 372px;
    overflow-y: auto;
    .van-radio {
      padding: 8px 0;
      font-size:var(--fs-md);
      line-height:var(--lh-md);
    }
  }
}
</style>